<template>
  <v-container>
   


  <v-row>
      <v-col cols="12" md="8">
        <div id="teacherOvlay">
        <div>
        <h1 v-if="!webinarStarted && !terminData.beendet" class="text-red mb-4">Sie sind noch nicht verbunden</h1>
        <h1 class="text-red mb-4" v-if="terminData.beendet">Webinar wurde beendet</h1>
        </div>
        <div class="teacher-main-video-controls-bar">
          <v-btn
            size="small"
            :color="isVideoPublished || isAudioPublished ? 'green' : 'red'"
            variant="elevated"
            @click="toggleLocalBroadcast"
          >
            <v-icon start>
              {{ (isVideoPublished || isAudioPublished) ? 'mdi-video-off' : 'mdi-video' }}
            </v-icon>
            {{ (isVideoPublished || isAudioPublished) ? 'Video &amp; Audio an' : 'Video &amp; Audio aus' }}
          </v-btn>
          <v-btn
            size="small"
            :color="isVideoPublished ? 'green' : 'red'"
            variant="elevated"
            @click="toggleLocalVideoOnly"
          >
            <v-icon start>{{ isVideoPublished ? 'mdi-video-off' : 'mdi-video' }}</v-icon>
            {{ isVideoPublished ? 'Video an' : 'Video aus' }}
          </v-btn>
          <v-btn
            size="small"
            :color="isAudioPublished ? 'green' : 'red'"
            variant="elevated"
            @click="toggleLocalAudio"
          >
            <v-icon start>{{ isAudioPublished ? 'mdi-microphone-off' : 'mdi-microphone' }}</v-icon>
            {{ isAudioPublished ? 'Mikro an' : 'Mikro aus' }}
          </v-btn>
          <v-btn
            size="small"
            color="primary"
            variant="outlined"
            @click="showPermissionsDialog = true"
          >
            Anleitung: Kamera/Mikro freigeben 
          </v-btn>
        </div>
        <div class="text-caption text-grey-darken-1 mb-2">
          Berechtigungen: Kamera {{ mediaPermissionStatus.camera }} · Mikro {{ mediaPermissionStatus.microphone }}
        </div>
        <v-dialog v-model="showPermissionsDialog" max-width="520">
          <v-card>
            <v-card-title>Browser-Berechtigungen</v-card-title>
            <v-card-text>
              <div class="mb-2">
                Status: Kamera <b>{{ mediaPermissionStatus.camera }}</b>,
                Mikro <b>{{ mediaPermissionStatus.microphone }}</b>
              </div>
              <div class="text-body-2 text-grey-darken-1">
                Du kannst die Berechtigung hier anfragen oder direkt die
                Browser-Einstellungen öffnen.
              </div>
              <div class="text-body-2 mt-3">
                <div class="mb-1"><b>Chrome/Edge</b>: Einstellungen → Datenschutz & Sicherheit → Website-Einstellungen → Kamera/Mikrofon → `{{ permissionOrigin }}` zulassen</div>
                <div class="mb-1"><b>Firefox</b>: Einstellungen → Datenschutz & Sicherheit → Berechtigungen → Kamera/Mikrofon → `{{ permissionOrigin }}` zulassen</div>
                <div class="mb-1"><b>Safari (macOS)</b>: Safari → Einstellungen → Websites → Kamera/Mikrofon → `{{ permissionHost }}` auf „Zulassen“</div>
                <div><b>macOS</b>: Systemeinstellungen → Datenschutz & Sicherheit → Kamera/Mikrofon → Browser aktivieren</div>
              </div>
            </v-card-text>
            
          </v-card>
        </v-dialog>
        <div class="border p-3" style="width: 100%; position: relative;" v-if="!terminData.beendet">
        <!-- Fragen-Anzahl Badge oben rechts -->
        <!-- <div v-if="fragen && fragen.length > 0" 
             style="position: absolute; top: 10px; right: 10px; z-index: 10; background: rgba(0,0,0,0.7); border-radius: 0; width: 60px; height: 60px; display: flex; align-items: center; justify-content: center;">
          <span style="color: #FF9800; font-size: 32px; font-weight: bold;">{{ fragen.length }}</span>
        </div> -->

        
        <!-- Badges vertikal links oben -->
        <div style="position: absolute; top: 15px; left: 15px; z-index: 10; display: flex; flex-direction: column; gap: 10px;">
          <!-- Teilnehmer Badge -->
          <div 
            v-if="allTeilnehmerInRoom && allTeilnehmerInRoom.length > 0" 
            @click="toggleFragenOverlayVisibility"
            style="background: rgba(33, 150, 243, 0.9); border-radius: 0; padding: 8px 12px; display: flex; align-items: center; gap: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.3); cursor: pointer; transition: background 0.2s;"
            @mouseover="$event.currentTarget.style.background = 'rgba(33, 150, 243, 1)'"
            @mouseleave="$event.currentTarget.style.background = 'rgba(33, 150, 243, 0.9)'"
            title="Klicken um Teilnehmerliste anzuzeigen"
          >
            <v-icon color="white" size="24">mdi-account-group</v-icon>
            <span style="color: white; font-size: 20px; font-weight: bold;">{{ allTeilnehmerInRoom.length }}</span>
          </div>
          
          <!-- Fragen Badge -->
          <div v-if="webinarStats && webinarStats.fragen > 0" 
                style="background: rgba(33, 150, 243, 0.9); border-radius: 0; padding: 8px 12px; display: flex; align-items: center; gap: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.3);">
            <v-icon color="white" size="24">mdi-help-circle</v-icon>
            <span style="color: white; font-size: 20px; font-weight: bold;">{{ webinarStats.fragen }}</span>
          </div>
          
          <!-- Danke Badge -->
          <div v-if="webinarStats && webinarStats.danke > 0" 
                style="background: rgba(244, 67, 54, 0.9); border-radius: 0; padding: 8px 12px; display: flex; align-items: center; gap: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.3);">
            <v-icon color="white" size="24">mdi-heart</v-icon>
            <span style="color: white; font-size: 20px; font-weight: bold;">{{ webinarStats.danke }}</span>
          </div>
          
          <!-- Interessant Badge -->
          <div v-if="webinarStats && webinarStats.interessant > 0" 
                style="background: rgba(255, 152, 0, 0.9); border-radius: 0; padding: 8px 12px; display: flex; align-items: center; gap: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.3);">
            <v-icon color="white" size="24">mdi-fire</v-icon>
            <span style="color: white; font-size: 20px; font-weight: bold;">{{ webinarStats.interessant }}</span>
          </div>
        </div>

        
        
        <template v-if="!presentationViewStarted">
          <div v-if="videoIsRunning && webinarStarted" class="teacher-main-video-container self-preview">
            <video ref="localVideoEl" class="teacher-main-video" autoplay muted playsinline></video>
            
            <!-- Recovery Button - erscheint bei schwarzem Bildschirm -->
            <div 
              v-if="!isVideoPublished || (webinarStarted && !videoIsRunning)" 
              style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 20; text-align: center; background: rgba(0,0,0,0.7); padding: 30px; border-radius: 0;"
            >
              <v-icon size="80" color="warning" class="mb-4">mdi-video-off-outline</v-icon>
              <div style="color: white; font-size: 18px; font-weight: bold; margin-bottom: 20px;">
                Kamera-Übertragung unterbrochen
              </div>
              <v-btn
                color="primary"
                size="large"
                prepend-icon="mdi-refresh"
                @click="reConnect"
              >
                Webinar-Übertragung neu starten
              </v-btn>
            </div>
            
            <!-- Status Icons unten rechts -->
            <div class="teacher-main-video-status">
              <!-- Video Status Icon -->
              <div class="teacher-status-chip">
                <v-icon 
                  :color="isVideoPublished ? 'green' : 'red'" 
                  size="20"
                >
                  {{ isVideoPublished ? 'mdi-video' : 'mdi-video-off' }}
                </v-icon>
              </div>
              
              <!-- Audio Status Icon -->
              <div class="teacher-status-chip">
                <v-icon 
                  :color="isAudioPublished ? 'green' : 'red'" 
                  size="20"
                >
                  {{ isAudioPublished ? 'mdi-microphone' : 'mdi-microphone-off' }}
                </v-icon>
              </div>
            </div>
            
            <!-- Reaktions-Animation Overlay -->
            <transition name="reaction-fade">
              <div v-if="reactionAnimation.visible" 
                   style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; display: flex; align-items: center; justify-content: center; z-index: 100; pointer-events: none;">
                <v-icon 
                  :color="reactionAnimation.color" 
                  size="200"
                  class="reaction-pulse">
                  {{ reactionAnimation.icon }}
                </v-icon>
              </div>
            </transition>
          </div>
          <div v-else class="teacher-video-placeholder">
            <!-- Dozentenbild anzeigen, wenn kein Video übertragen wird -->
            <img
              v-if="dozentImageSrc"
              :src="dozentImageSrc"
              alt="Dozent"
              class="teacher-video-placeholder-image"
            >

            <h1 v-if="terminData.open" class="teacher-video-placeholder-text">
              Das Webinar "{{terminData.webi_title}}" wird in Kürze gestartet
            </h1>
            
            <!-- Reaktions-Animation Overlay (auch ohne Video) -->
            <transition name="reaction-fade">
              <div v-if="reactionAnimation.visible" 
                   style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; display: flex; align-items: center; justify-content: center; z-index: 100; pointer-events: none;">
                <v-icon 
                  :color="reactionAnimation.color" 
                  size="200"
                  class="reaction-pulse">
                  {{ reactionAnimation.icon }}
                </v-icon>
              </div>
            </transition>
          </div>
        </template>
        <template v-else>
          <div class="teacher-presentation-inline-wrapper">
            <div class="teacher-presentation-stage">
              <img
                v-if="activePictureBroadCast.type == 'picture'"
                class="teacher-presentation-media"
                :src="`/videos/webinar${slideShowNumber}/slides/${activePictureBroadCast.url}`"
              >
              <video
                v-else
                class="teacher-presentation-media"
                :src="`${activePictureBroadCast.url}`"
                controls
                muted
                autoplay
                @loadeddata="onVideoLoaded"
              >
                Ihr Browser unterstützt das Video-Element nicht.
              </video>

              <div
                v-if="showInlineTeacherPreview"
                class="teacher-inline-preview self-preview"
              >
                <video
                  ref="localInlineVideoEl"
                  class="teacher-inline-preview-video"
                  autoplay
                  muted
                  playsinline
                ></video>
                
                <!-- Recovery Button im Inline-Preview wenn Video schwarz -->
                <div 
                  v-if="!isVideoPublished"
                  style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 20; text-align: center;"
                >
                  <v-icon size="40" color="warning" class="mb-2">mdi-video-off-outline</v-icon>
                  <div style="color: white; font-size: 12px; font-weight: bold; margin-bottom: 10px; text-shadow: 2px 2px 4px rgba(0,0,0,0.8);">
                    Kamera aus
                  </div>
                  <v-btn
                    color="primary"
                    size="small"
                    @click="reConnect"
                  >
                    Neu starten
                  </v-btn>
                </div>
              </div>
            </div>
          </div>

      
          <!-- Versteckte Videos und Bilder zum Vorladen -->
          <div style="display: none;">
            <video v-for="videoUrl in preloadedVideoUrls" :key="videoUrl" :src="`${videoUrl}`" preload="auto"></video>
            <img v-for="imageUrl in preloadedImageUrls" :key="imageUrl" :src="`${imageUrl}`" />
          </div>
        
          <v-row v-if="startPresentation">
            <v-col cols="6">
              <v-btn
                style="height: 50px;"
                size="100%"
                color="green"
                v-if="numberPictureBroadCast < countSlides"
                @click="setPictureBroadCast(1,'plus')"
              >
                nächstes Slide  {{ numberPictureBroadCast }}/{{ countSlides }}
              </v-btn>
              <v-btn
                style="height: 50px;"
                size="100%"
                color="red"
                v-if="numberPictureBroadCast > 1"
                @click="setPictureBroadCast(1,'minus')"
              >
                zurück
              </v-btn>
            </v-col>
            <v-col cols="6">
              <img
                v-if="nextSlide.type == 'picture'"
                style="width: 100%; height: 100%; object-fit: cover; margin-bottom: 16px;"
                :src="`/videos/webinar${slideShowNumber}/slides/${nextSlide.url}`"
              >
              <div v-if="nextSlide.type == 'video'" style="width: 100%; height: 100%; margin-bottom: 16px;" >
               <h2>Video</h2>
              </div>
            </v-col>
          </v-row>
        </template>
      </div>  
      <v-row class="my-4">
        <v-col cols="6"><v-btn style="height: 50px;" size="100%" :color="presentationViewStarted ? 'green' : 'primary'" @click="startPresentationSend('start')">start Präsentation</v-btn></v-col>
        <v-col cols="6"><v-btn style="height: 50px;" size="100%" :color="!presentationViewStarted ? 'red' : 'primary'" @click="startPresentationSend('end')">stop Präsentation</v-btn></v-col>
       </v-row>
      <v-row class="my-4">
        <v-col cols="12">
          <!-- Übertragungseinstellungen (Kamera & Mikrofon) -->
          <v-expansion-panels class="mb-4">
            <v-expansion-panel>
              <v-expansion-panel-title>
                <v-icon start class="mr-2">mdi-cog</v-icon>
                Übertragungseinstellungen
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <!-- Kamera-Auswahl -->
                <v-row v-if="videoDevices.length > 0" class="mb-4">
                  <v-col cols="6">
                    <v-select
                      v-model="selectedCameraId"
                      :items="videoDevices"
                      item-title="label"
                      item-value="deviceId"
                      label="Kamera auswählen"
                      @update:modelValue="changeCamera"
                    >
                      <template v-slot:item="{ props, item }">
                        <v-list-item v-bind="props" :title="item.raw.label || `Kamera ${item.raw.deviceId.substring(0, 8)}...`"></v-list-item>
                      </template>
                      <template v-slot:selection="{ item }">
                        {{ item.raw.label || `Kamera ${item.raw.deviceId.substring(0, 8)}...` }}
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="2">
                    <v-btn @click="getVideoDevices" color="grey" variant="outlined" class="mt-3">
                      Neu suchen
                    </v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn @click="startScreenCapture" color="primary" variant="outlined" class="mt-3 ml-2">
                      Browser teilen
                    </v-btn>
                    <v-btn
                      @click="switchBackToCamera"
                      :disabled="!isScreenSharing || !selectedCameraId"
                      color="grey"
                      variant="outlined"
                      class="mt-3 ml-2"
                    >
                      Kamera nutzen
                    </v-btn>
                    <v-btn v-if="showDebug" @click="logPublishStatus" color="orange" variant="outlined" class="mt-3 ml-2">
                      Debug Status
                    </v-btn>
                  </v-col>
                </v-row>

                <!-- Mikrofon Auswahl -->
                <v-row>
                  <v-col cols="6">
                    <v-select
                      v-if="audioDevices.length > 0"
                      v-model="selectedAudioDevice"
                      :items="audioDevices"
                      item-title="label"
                      item-value="deviceId"
                      label="Mikrofon auswählen"
                      variant="outlined"
                      density="compact"
                      @update:model-value="changeAudioDevice"
                    >
                      <template v-slot:selection="{ item }">
                        <v-icon start>mdi-microphone</v-icon>
                        {{ item.title }}
                      </template>
                <template v-slot:item="{ props }">
                  <v-list-item v-bind="props">
                    <template v-slot:prepend>
                      <v-icon>mdi-microphone</v-icon>
                    </template>
                  </v-list-item>
                </template>
                    </v-select>
                    <div v-else class="text-body-2 text-grey">
                      Kein Mikrofon erkannt. Bitte Gerät prüfen und „Neu suchen“ klicken.
                    </div>
                  </v-col>
                  <v-col cols="2">
                    <v-btn @click="getAudioDevices" color="grey" variant="outlined">
                      Neu suchen
                    </v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn @click="resetAudio" color="orange" variant="outlined" class="ml-2">
                      🔄 Audio zurücksetzen
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
      
      
         <v-row>
          <v-col cols="12">
          <span v-if="isOpen && !webinarStarted" >
            <v-btn class="mr-4 pa-2" style="height: 40px;font-size: 20px;" width="100%" color="primary" @click="getAdminSession">hier klicken um das Webinar zu starten</v-btn>
          </span>
          <span v-if="!isOpen && !webinarStarted ">
            <v-btn class="mr-4 pa-2" style="height: 40px;font-size: 20px;" width="100%"  disabled @click="getAdminSession">hier klicken um das Webinar zu starten</v-btn>
          </span>
          <span v-if="isOpen &&  webinarStarted">
            <v-btn class="mr-4 pa-2" style="height: 40px;font-size: 20px;"  width="100%" color="primary"  @click="reConnect"> Webinar Übertragung neu starten</v-btn>
          </span>
          <span v-if="isOpen &&  webinarStarted && isConnected && showEndButton" style="display: block;">
            <v-btn
              color="red"
              width="100%"
              style="height: 40px;font-size: 20px;"
              class="my-2 pa-2"
              @click="handleEndWebinarClick"
            >
              Webinar jetzt beenden
            </v-btn>
            <div
              v-if="showEndWebinarConfirm"
              class="end-webinar-confirm mt-2"
            >
              <div class="confirm-title">Bitte bestätigen:</div>
              <v-checkbox
                :model-value="confirmEndWebinar"
                @update:model-value="confirmEndWebinarChanged"
                color="red"
                density="compact"
                hide-details
                label="Ja, ich möchte das Webinar wirklich beenden"
              />
            </div>
          </span>
          <!-- <v-btn  color="orange"  width="100%" style="height: 40px;font-size: 20px;" class="my-6 pa-2" @click="startBackupDialog">Zoom Backup Dialog öffnen</v-btn> -->
          </v-col>
      
          </v-row>
     
        </v-col>

      </v-row>
    </div>
         <v-row>
        <v-col cols="12">
          <h4  v-if="terminData && terminData.webi_title">{{terminData.webi_title}} </h4>
          Beginn:{{ terminData.beginn }} | Dozent: {{ terminData.dozent }}
        </v-col>
      </v-row>

<!-- Debug Info -->
<div v-if="showDebug" style="position: fixed; top: 10px; left: 10px; background: red; color: white; padding: 10px; z-index: 9999;">
  Debug: fragenOverlayVisible = {{ fragenOverlayVisible }}, isDesktop = {{ baseStore?.isDesktop }}
</div>

 <div id="fragenOverlay" 
      class="draggable-fragen-overlay" 
      :style="fragenOverlayStyle"
      ref="fragenOverlayRef">
      
        <!-- Fragen Overlay Header für Drag -->
        <div class="fragen-overlay-header" @mousedown="startFragenDrag">
          <span>Teilnehmer ({{ allTeilnehmerInRoom.length }})</span>
          <div class="d-flex gap-1">
            <v-btn @click="toggleFragenOverlay" class="fragen-overlay-minimize" icon size="small" variant="text">
              <v-icon color="white">{{ fragenOverlayMinimized ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
            <v-btn @click.stop="fragenOverlayVisible = false" class="fragen-overlay-minimize" icon size="small" variant="text" title="Schließen">
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
        
        <!-- Fragen Overlay Content -->
        <div class="fragen-overlay-content" v-if="!fragenOverlayMinimized">
          <h3 v-if="!allTeilnehmerInRoom || allTeilnehmerInRoom.length === 0">Es sind noch keine Teilnehmer eingeloggt</h3>
      <v-row v-if="allTeilnehmerInRoom && allTeilnehmerInRoom.length > 0" class="mt-4">
        <v-col cols="12">
          <v-row>
        <v-col cols="11">
   
        <div v-for="item in getParticipantsBroadcastStatus()" :key="item.identity" class="mb-2 py-2" style="border-bottom: 1px solid #ccc;">
          <v-row class="align-center">
            <v-col cols="5">
              <h4>{{ getNameFromTeilnehmer(item.identity,'name') }}
                <h4 v-if="getNameFromTeilnehmer(item.identity,'admin') == 1" class="text-green">Dozent</h4>
                <h4 v-else-if="getNameFromTeilnehmer(item.identity,'admin') == 2" class="text-green">Co-Admin</h4>
              </h4>
            
            </v-col>
            <v-col cols="3" class="d-flex align-center" style="gap: 8px;">

              <v-icon v-if="!item.isBroadcasting && (getNameFromTeilnehmer(item.identity,'admin') == 2 || getNameFromTeilnehmer(item.identity,'admin') == 0)" color="green">mdi-eye</v-icon>
              <v-icon :color="item.hasVideo ? 'green' : 'red'">{{ item.hasVideo ? 'mdi-video' : 'mdi-video-off' }}</v-icon>
              <v-icon :color="item.hasAudio ? 'green' : 'red'">{{ item.hasAudio ? 'mdi-microphone' : 'mdi-microphone-off' }}</v-icon>
            </v-col>
            <v-col cols="4">
            <span v-if="(getNameFromTeilnehmer(item.identity,'admin') == 2 || getNameFromTeilnehmer(item.identity,'admin') == 0)">
             
              <v-btn v-if="AUDIENCE_LIVE_ENABLED && !item.isBroadcasting"  @click="setUserVideoOnDirect(1,item)" class="mr-2" color="red">= off </v-btn>
              <v-btn v-if="item.isBroadcasting" @click="setUserVideoOnDirect(0,item)" class="mr-2" color="green">= live</v-btn>
              <v-btn
                v-if="item.isBroadcasting && item.hasVideo"
             
                variant="text"
                icon
                :color="currentInlineVideoIdentity === item.identity ? 'red' : 'primary'"
                :title="currentInlineVideoIdentity === item.identity ? 'Inline-Video ausblenden' : 'Inline-Video anzeigen'"
                @click="toggleInlineVideo(item.identity)"
              >
                <v-icon>{{ currentInlineVideoIdentity === item.identity ? 'mdi-television-off' : 'mdi-television' }}</v-icon>
              </v-btn>
          
            </span>
         
            </v-col>
          </v-row>
        </div>
            </v-col>
            </v-row>
 

      
    
            </v-col>
          </v-row>
      </div> <!-- Ende fragen-overlay-content -->
      </div> <!-- Ende fragenOverlay -->

      </v-col>
      <v-col cols="12" md="4" class="pl-8">
     
        <!-- Container mit Vue v-for Schleife -->
        <div v-if="activeVideos.length > 0">
        
          
          <!-- Vue-basierte Video Container -->
          <div style="display: flex; flex-wrap: wrap; gap: 15px; background: #fff; padding: 10px;">
            <div 
              v-for="video in activeVideos" 
              :key="video.identity"
              :id="`video-container-${video.identity.replace('_', '-')}`"
              style="margin: 10px; padding: 10px; width: 100%; background: white;"
            >
            <div v-if="getNameFromTeilnehmer(video.identity,'admin') == 2" >
              <h2 class="text-orange">Co-Admin: {{ getNameFromTeilnehmer(video.identity,'name') }}</h2>
        </div>
 
         
              <!-- Video Bereich -->
              <div 
                :ref="`videoContainer-${video.identity}`"
                class="video-area"
                style="width: 100%; height: 300px; background: #000; margin-bottom: 5px;"
              >
                <!-- Das Video-Element wird hier per JavaScript eingefügt -->
              </div>
              
              <!-- Button -->
              <v-btn 
                @click="setUserVideoOnDirect(0,video)"
                color="red"
                width="100%"
              >
                Video   {{ video.name }} beenden
              </v-btn>
            
            </div>
          </div>
        </div>
        
        <!-- Debug-Info -->
        <div v-if="showDebug" style="background: #ffffcc; padding: 10px; margin: 10px 0;">
          <h4>Debug Info:</h4>
          <p>ActiveVideos Array: {{ activeVideos.length }} Einträge</p>
          <div v-for="video in activeVideos" :key="video.identity">
            - {{ video.identity }}: {{ video.name }} (Container: video-container-{{ video.identity.replace('_', '-') }})
          </div>
          <p><strong>Container IDs im DOM:</strong></p>
          <div style="font-size: 12px; color: #666;">
            <button @click="checkDOMContainers" style="background: #007bff; color: white; padding: 5px 10px; border: none; border-radius: 0; cursor: pointer;">
              🔍 Container im DOM prüfen
            </button>
            <div v-if="domContainerInfo" style="margin-top: 10px; font-family: monospace; background: #f0f0f0; padding: 10px; border-radius: 0;">
              {{ domContainerInfo }}
            </div>
          </div>
        </div>
        
        <!-- Fallback für altes System -->
        <div v-if="activeFrage && activeVideos.length === 0" class="my-4">
          <span><h2>Frage von: {{ speakerName }}</h2></span>
        <v-btn @click="setUserVideoOn(1,activeFrage)" class="mr-2" color="green">nochmal starten</v-btn>
        <v-btn @click="setUserVideoOn(0,activeFrage)" class="mr-2" color="red">Frage beenden</v-btn>
      </div>
      

        <div v-if="broadCastWebinar">
          <!-- <video 
            ref="webinarVideoEl"
            controls 
            style="width: 300px; height: 100%; object-fit: cover; margin-bottom: 16px;"
            @loadeddata="onWebinarVideoLoaded"
            crossorigin="anonymous"
            preload="auto"
          >
            <source src="/videos/webinar4/slides/video5.mp4" type="video/mp4">
            Ihr Browser unterstützt das Video-Element nicht.
          </video> -->
          <div class="mt-2">
            <v-btn @click="streamWebinarVideo" :disabled="!isConnected || !webinarVideoReady || (webinarVideoTrack && !webinarVideoEl?.paused)" color="primary" class="mr-2">
              {{ webinarVideoEl?.paused ? '▶️ Fortsetzen' : '📹 Video streamen' }}
            </v-btn>
            <v-btn @click="stopWebinarVideoStream" :disabled="!isConnected || !webinarVideoTrack" color="orange" class="mr-2">
              ⏸️ Pausieren (Standbild)
            </v-btn>
            <v-btn @click="stopWebinarVideoCompletely" :disabled="!isConnected || !webinarVideoTrack" color="red" class="mr-2">
              ⏹️ Komplett stoppen
            </v-btn>
          </div>
        </div>

       
        <div v-if="!broadCastWebinar && slideShowNumber > 0">
   
        </div>


        <div v-if="showUserChat && isConnected"  style="border: 4px solid #f2f2f2;padding: 10px;">
      <h3 class="mb-2" style="color: #3d1b70;">Chat</h3>
      <div ref="chatMessagesContainer" class="mb-2" style="max-height: 180px; min-height: 100px; overflow-y: auto;">
   
          <div v-if="chatMessages.length === 0" class="text-center text-grey">
            Noch keine Nachrichten im Chat
          </div>
          <div
            v-for="(msg, index) in chatMessages"
            :key="index"
            class="mb-1 pb-1 chat-message"
            :class="{ 'chat-message--me': msg.from === 'admin_' + wteiId }"
          >
            <div class="text-body-2 mb-1">{{ msg.text }}</div>
            <div class="text-right">
              <span class="text-caption text-grey-darken-1">
                <b>{{ msg.from === 'admin_' + wteiId ? 'Ich' : (msg.displayName || getNameFromTeilnehmer(msg.from, 'name')) }}</b>
                · {{ formatTime(msg.ts) }} · {{ getTimeAgo(msg.ts) }}
              </span>

              
            </div>
          </div>
    
       </div>
      <v-textarea
        v-model="chatInput"
        label="Schreiben Sie Ihre Nachricht hier und senden Sie sie mit Enter"
        rows="2"
        auto-grow
        hide-details
        @keydown.enter.prevent="sendChatMessage"
        class="mt-2"
      />
    </div>

          <!-- Teilnehmer-Chat direkt unter den Präsentations-Buttons -->
      
      <!-- <div v-for="item in teilnehmerFragen" :key="item.id">
        <h3>{{ item.id }}</h3>
      </div> -->

       <div
            v-if="!showUserChat"
            id="activeFragen" 
            class="draggable-active-fragen-overlay" 
            :style="activeFragenOverlayStyle"
            ref="activeFragenOverlayRef">
            
          <!-- Active Fragen Overlay Header für Drag -->
          <div class="active-fragen-overlay-header" @mousedown="startActiveFragenDrag" >
            <span v-if="teilnehmerFragen.length > 0">Teilnehmer-Fragen ({{ teilnehmerFragen.length }})</span>
            <span v-if="teilnehmerFragen.length === 0">Es wurde noch keine Frage gestellt</span>
            <v-btn @click="toggleActiveFragenOverlay" class="active-fragen-overlay-minimize" icon size="small" variant="text">
              <v-icon color="white">{{ activeFragenOverlayMinimized ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </div>
          
          <!-- Active Fragen Overlay Content -->
          <div class="active-fragen-overlay-content" v-if="!activeFragenOverlayMinimized">
      
        <!-- <div v-if="fragen && fragen.length > 0" style="background: #f0f0f0; padding: 5px; margin-bottom: 10px; font-size: 12px;">
          Debug: {{ fragen.length }} Fragen gefunden
        </div> -->
        <div v-if="teilnehmerFragen.length > 0" style="width: 100%;">
      
      <div class="my-8 pb-2" style="border-bottom: 1px solid #ccc;background-color: #f2f2f2;"  v-for="item in teilnehmerFragen" :key="item.id">

        <v-row >
          <v-col cols="1">
          <v-icon :color="AudienceVideoIsRunning ? 'green' : 'grey'" style="font-size: 33px;" :class="AudienceVideoIsRunning ? 'pulsing-heart' : ''">mdi-video</v-icon>
            </v-col>
        <v-col cols="7">
        Frage gestellt vor  <span class="text-green" v-if="item.vor < 2">{{ item.vor }} Minuten</span> <span v-if="item.vor > 1">{{ item.vor }} Minuten</span> | {{ item.teilnehmerid }}
          <h3>{{ item.name }} </h3> 
            
            </v-col>
        <v-col cols="4">
          <span  v-if="!isUserOnline(item.teilnehmerid)">
            <v-btn  color="red">Offline</v-btn>
            </span>
        <span  v-if="isUserOnline(item.teilnehmerid)">
           <v-btn v-if="AUDIENCE_LIVE_ENABLED && item.video == 0" 
                  @click="setUserVideoOn(1,item)" 
                  class="mb-2" 
                  :color="item.video == 1 ? 'green' : 'green'" 
                  size="small"
                  style="width: 100%; height: 40px; font-size: 14px;">
            live schalten
           </v-btn>
           <v-btn v-if="item.video == 1" 
           
                  @click="setUserVideoOn(0,item)" 
                  color="red"
                  size="small"
                  style="width: 100%; height: 40px; font-size: 14x;">
            ausschalten
           </v-btn>
          </span>
        </v-col>
          </v-row>
        
      <v-row  class="pa-2" >
              <v-col cols="8">
                <div style="background-color: #fff;" class="pa-4 ml-2">
          <em >{{ item.frage }}</em> 
        </div>
      </v-col>
          <v-col cols="4">
            
            <v-btn @click="SetStatusFrage(3,item)" class="mb-2" :color="item.status == 3 ? 'blue' : ''" size="small">Frage wurde beantwortet</v-btn><br>
            <v-btn @click="SetStatusFrage(4,item)"  :color="item.status == 4 ? 'red' : ''" size="small">Frage löschen</v-btn>
      </v-col>
      </v-row>


      </div>

    </div>
    </div> <!-- Ende active-fragen-overlay-content -->
    </div> <!-- Ende activeFragen -->
    

      <!-- DataTrack Anzeige -->
    
    
   
      </v-col>

    </v-row>
    <v-row v-if="showDebug" class="mt-12" style="border-top: 1px solid #ccc;background-color: #f0f0f0;">
      <v-col cols="6">
        
    

        
  <h2>Start Admin  <span v-if="isConnected" class="text-green">connected</span> <span v-else class="text-error">disconnected</span></h2>

  open {{ isOpen }} webinarStarted {{ webinarStarted }} - tokenBis {{ tokenBis }} - connected {{ isConnected }}<br>
 | WebinarStarted {{ webinarStarted }} | WebinarTerminId {{ webinarTerminId }} userWebinarTerminId {{ userWebinarTerminId }}
   <br>
   {{ videoContainerClassAudience }} | AudienceVideoIsRunning {{ AudienceVideoIsRunning }}
   <br>
{{ terminData.wter_id }}

<br>
   <v-textarea v-model="token" label="Token" />
   <br> 
   WteilId {{ wteiId }}<br>
   <span v-if="isOpen" >
    <v-btn @click="getAdminSession">start admin</v-btn></span>
  
   <v-btn @click="reConnect">reConnect</v-btn>
   {{ room }}
   <!-- Lokales Video für Admin -->
   <v-row  class="mt-4">
     <v-col cols="12" md="6">
       <v-card>
     
       </v-card>
     </v-col>
   </v-row>
   <div class="space-y-3" v-if="room">
    <div class="flex gap-2">
      <input v-model="webinarTerminId" class="border rounded px-2 py-1" placeholder="Termin-ID" />
      <input v-model="token" class="border rounded px-2 py-1 w-[28rem]" placeholder="Twilio Access Token" />
      <button @click="joinRoom" :disabled="isConnected" class="px-3 py-1 rounded bg-blue-600  disabled:opacity-50">
        Join
      </button>
      <button @click="leaveRoom" :disabled="!isConnected" class="px-3 py-1 rounded bg-gray-700  disabled:opacity-50">
        Leave
      </button>
      <button @click="publishVideo" :disabled="!isConnected" class="px-3 py-1 rounded bg-green-600 disabled:opacity-50">
        Video An
      </button>
      <button @click="unpublishVideo" :disabled="!isConnected" class="px-3 py-1 rounded bg-red-600  disabled:opacity-50">
        Video Aus
      </button>
    </div>

    <!-- <div class="rounded border p-3">
      <h3 class="font-semibold mb-2">Deine Kamera</h3>
      <video ref="localVideoEl" autoplay muted playsinline class="w-full rounded bg-black"></video>
    </div>-->
  </div> 
</v-col>
<v-col cols="1"></v-col>
<v-col cols="5">
      <v-row>
        <v-col cols="12">
          <!-- User Chat -->
          <div v-if="showUserChat" class="mb-4">
            <h2>Teilnehmer-Chat</h2>
            <v-card class="mb-2" style="max-height: 350px; overflow-y: auto;">
              <v-card-text>
                <div v-if="chatMessages.length === 0" class="text-center text-grey">
                  Noch keine Nachrichten
                </div>
                <div
                  v-for="(msg, index) in chatMessages"
                  :key="index"
                  class="mb-1 pb-1 chat-message"
                  :class="{ 'chat-message--me': msg.from === 'admin_' + wteiId }"
                >
                  <div class="text-body-2 mb-1">{{ msg.text }}</div>
                  <div class="text-right">
                    <span class="text-caption text-grey-darken-1">
                      <b>{{ msg.from === 'admin_' + wteiId ? 'Ich' : (msg.displayName || getNameFromTeilnehmer(msg.from, 'name')) }}</b>
                      · {{ formatTime(msg.ts) }} · {{ getTimeAgo(msg.ts) }}
                    </span>
                  </div>
                </div>
              </v-card-text>
            </v-card>
            <v-textarea
              v-model="chatInput"
              label="Nachricht an alle"
              rows="2"
              auto-grow
              hide-details
              @keydown.enter.prevent="sendChatMessage"
            />
          </div>

          <!-- DataTrack Nachrichten Debug -->
          <h2>DataTrack Nachrichten</h2>
          {{ activeFrage}}
          <v-card class="mb-4" style="max-height: 300px; overflow-y: auto;">
            <v-card-text>
              <div v-if="dataTrackMessages.length === 0" class="text-center text-grey">
                Keine DataTrack Nachrichten
              </div>
              <div v-for="(message, index) in dataTrackMessages" :key="index" class="mb-2 pa-2" 
                   :class="message.type === 'sent' ? 'bg-blue-lighten-5' : 'bg-green-lighten-5'">
                <div class="d-flex justify-space-between">
                  <strong>{{ message.type === 'sent' ? 'Gesendet' : `Von ${message.from}` }}</strong>
                  <small>{{ message.timestamp }}</small>
                </div>
                <div>{{ message.content }}</div>
              </div>
            </v-card-text>
          </v-card>
          
          <!-- Test-Nachricht senden -->
          <v-row>
            <v-col cols="8">
              <v-text-field 
                v-model="testMessage" 
                label="Test-Nachricht" 
                placeholder="Nachricht eingeben..."
                @keyup.enter="sendTestMessage"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-btn @click="sendTestMessage" color="primary" :disabled="!testMessage.trim()">
                Senden
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
</v-col>
</v-row>


  </v-container>
</template>

<script setup>
//http://localhost:8080/dozent/181/weljkrw23423423
//https://www.dentinar.de/dozent/181/weljkrw23423423

import { inject, ref, onMounted, onUnmounted, computed, watch, markRaw, shallowRef, nextTick } from "vue";

import {
  testVideoInputDevice,
  testAudioInputDevice,
} from '@twilio/rtc-diagnostics';




const Video = require('twilio-video');
const baseCalls = inject('baseCalls');
const updateDocumentHead = inject('updateDocumentHead');
import { storeToRefs } from 'pinia'
import { useRoute } from "vue-router";
import { useUserStore } from '@/stores/userStore';
const loaderStore = inject('loaderStore')
const baseStore = inject('baseStore')
const userStore = useUserStore();
import { useWebinarStore } from '@/stores/webinarStore';
import { AUDIENCE_LIVE_ENABLED } from '@/services/webinarFeatures';
const { userToken,userWebinarTerminId } = storeToRefs(userStore)
const isConnected = ref(false);
const startPresentation = ref(true);
const slideShowNumber = ref(0); const switchPresentationButton = ref(true);
const showEndButton = ref(false);
//const showSelectCamera = ref(false);

// Video/Image Preload Management
const preloadedVideos = ref(new Set())
const preloadedImages = ref(new Set())
const preloadedVideoUrls = computed(() => Array.from(preloadedVideos.value))
const preloadedImageUrls = computed(() => Array.from(preloadedImages.value))

// Fragen Overlay Drag Variablen
const fragenOverlayRef = ref(null);
const fragenOverlayVisible = ref(false); // Initial versteckt, wird durch Badge-Click geöffnet
const fragenOverlayMinimized = ref(false);
const fragenOverlayPosition = ref({ x: 130, y: 400 });
const fragenIsDragging = ref(false);
const fragenDragStart = ref({ x: 0, y: 0 });

// Active Fragen Overlay Drag Variablen
const activeFragenOverlayRef = ref(null);
const activeFragenOverlayVisible = ref(true);
const activeFragenOverlayMinimized = ref(false);
const activeFragenOverlayPosition = ref({ x: 800, y:700 });
const activeFragenIsDragging = ref(false);
const activeFragenDragStart = ref({ x: 0, y: 0 });

// Computed Style für Fragen Overlay
const fragenOverlayStyle = computed(() => ({
  display: fragenOverlayVisible.value ? 'block' : 'none',
  position: 'fixed',
  left: fragenOverlayPosition.value.x + 'px',
  top: fragenOverlayPosition.value.y + 'px',
  zIndex: 1000,
  minWidth: '600px',
  maxWidth: '800px',
  maxHeight: '90vh',
  height: 'auto'
}));

// Computed Style für Active Fragen Overlay
const activeFragenOverlayStyle = computed(() => ({
  display: activeFragenOverlayVisible.value ? 'block' : 'none',
  position: 'fixed',
  left: activeFragenOverlayPosition.value.x + 'px',
  top: activeFragenOverlayPosition.value.y + 'px',
  zIndex: 1000,
  minWidth: '800px',
  maxWidth: '900px',
  maxHeight: '90vh',
  height: 'auto',
  minHeight: '300px'
}));

const route = useRoute();
const token = ref('');
const tokenBis = ref('');
const terminData  = ref(false);
const webinarStarted = ref(false);
const webinarTerminId = ref(false);
const wteiId = ref(0);
const room = ref(null);
const speakerName = ref('');
const audience = ref([]);
const fragen = ref(false);
// Fragenliste ohne Antworten von Dozent/Admin (die stehen nur im Chat)
const teilnehmerFragen = computed(() => (Array.isArray(fragen.value) ? fragen.value : []).filter(f => !f.team));
const videoIsRunning = ref(true);
const lastFrageIdentity = ref('');
const AudienceVideoIsRunning = ref(false);
const broadCastWebinar = ref(false)
const countSlides = ref(1)
const countReconnects = ref(0)
const webinarStats = ref({
  fragen: 0,
  danke: 0,
  interessant: 0,
});
// Initial-Flag für Chat-History aus wtb_webinar_fragen
const initialChatLoaded = ref(false);
const confirmEndWebinar = ref(false);
const showEndWebinarConfirm = ref(false);

// Reaktions-Animation über Admin-Video
const reactionAnimation = ref({
  visible: false,
  icon: '',
  color: ''
});

// Dozentenbild aus terminData (Datei liegt in public/dozenten/)
const dozentImageSrc = computed(() => {
  try {
    if (!terminData.value || !terminData.value.dozent_image) return null;
    const img = terminData.value.dozent_image;
    if (typeof img !== 'string' || img.length === 0) return null;
    // Wenn bereits absoluter Pfad, direkt verwenden
    if (img.startsWith('/')) return img;
    // Sonst aus public/dozenten laden
    return `/dozenten/${img}`;
  } catch (e) {
    console.warn('Fehler beim Ermitteln des Dozentenbildes:', e);
    return null;
  }
});

// Neue Variable für mehrere aktive Videos
const activeVideos = ref([]); // Array von {identity, name, track, participant}

// Debug Variable für DOM Container Info
const domContainerInfo = ref('');

const videoContainerClassAudience = computed(() => {
  return (AudienceVideoIsRunning.value || activeVideos.value.length > 0) ? 'video-container' : 'hidden-video-container';
});

// Helper-Computed um zu prüfen ob ein User online ist
const isUserOnline = computed(() => {
  return (id) => {
    const identity = 'audience_' + id;
    console.log('Prüfe User Online in allTeilnehmerInRoom:', id, '→', identity);
    
    // Durchsuche allTeilnehmerInRoom nach dem User
    const foundUser = allTeilnehmerInRoom.value.find(participant => 
      participant.identity === identity && participant.state === 'connected'
    );
    
    if (foundUser) {
      console.log('User ist online (gefunden in allTeilnehmerInRoom):', identity);
      return true;
    }
    
    console.log('User ist offline (nicht in allTeilnehmerInRoom gefunden):', identity);
    return false;
  };
});

const numberPictureBroadCast = ref(1) 
const webinarStore = useWebinarStore()

// Slides für aktuelles Webinar
const currentWebinarSlides = computed(() => {
  return webinarStore.pictureBroadCast && webinarStore.pictureBroadCast[slideShowNumber.value] 
    ? webinarStore.pictureBroadCast[slideShowNumber.value] 
    : {};
});

const pictureBroadCast = ref(webinarStore.pictureBroadCast)
const activePictureBroadCast = ref(
  currentWebinarSlides.value && currentWebinarSlides.value[1]
    ? currentWebinarSlides.value[1]
    : { url: '', type: 'picture' }
)
const nextSlide = ref(
  currentWebinarSlides.value && currentWebinarSlides.value[2]
    ? currentWebinarSlides.value[2]
    : { url: '', type: 'picture' }
)

// Wenn Slides für ein Webinar geladen werden, initial die erste(n) Slide(s) setzen
watch(currentWebinarSlides, (slides) => {
  if (!slides || Object.keys(slides).length === 0) return;

  // Wenn bereits ein aktives Bild gesetzt ist, nichts überschreiben
  if (activePictureBroadCast.value && activePictureBroadCast.value.url) return;

  // Startindex: aktueller numberPictureBroadCast oder 1
  let startIndex = numberPictureBroadCast.value || 1;
  if (!slides[startIndex]) {
    startIndex = 1;
  }

  const current = slides[startIndex];
  const next = slides[startIndex + 1] || { url: '', type: 'picture' };

  if (current) {
    activePictureBroadCast.value = current;
    nextSlide.value = next;
    numberPictureBroadCast.value = startIndex;
    console.log('✅ Initiales Slide gesetzt:', startIndex, current.url);
  }
});
const currentVideo = ref(null)



const localVideoTrack = ref(null)
const localDataTrack = shallowRef(null)
const localAudioTrack = ref(null) // Audio-Track aktiviert
const localVideoEl = ref(null)
const localInlineVideoEl = ref(null)
const activeFrage = ref(false);
const showDebug = ref(false)

// User Interaction Monitoring
const mousePosition = ref({ x: 0, y: 0 })
const lastMouseClick = ref(null)
const lastKeyPress = ref(null)
const activeKeys = ref([])
const lastScroll = ref(null)
const scrollPosition = ref({ x: 0, y: 0 })
const interactionLog = ref([])
const allTeilnehmerInRoom = ref([])

// Webinar Video Streaming
const webinarVideoEl = ref(null)
const webinarVideoTrack = ref(null)
const webinarVideoReady = ref(false)
const isStreamingWebinarVideo = ref(false)

// Kamera-Auswahl
const videoDevices = ref([]);
const selectedCameraId = ref('');
const isScreenSharing = ref(false);

// Mikrofon-Auswahl
const audioDevices = ref([]);
const selectedAudioDevice = ref('');

// Status für Video/Audio Broadcasting
const isVideoPublished = ref(false);
const isAudioPublished = ref(false);
const mediaPermissionStatus = ref({
  camera: 'unbekannt',
  microphone: 'unbekannt'
});
const showPermissionsDialog = ref(false);
const permissionOrigin = ref('');
const permissionHost = ref('');
const presentationViewStarted = ref(false)
const showInlineTeacherPreview = computed(
  () => presentationViewStarted.value && videoIsRunning.value && isVideoPublished.value
)

function startPresentationSend(type) {
  let identity = '';
  identity = 'admin_' + wteiId.value;
  if (type == 'start') {
    presentationViewStarted.value = true;
    sendDataMessage({ type: 'pictureBroadCastStarted', from: identity, ts: Date.now() });
  }
  if (type == 'end') {
    presentationViewStarted.value = false;
    sendDataMessage({ type: 'pictureBroadCastEnded', from: identity, ts: Date.now() });
  }
}

function detachLocalInlinePreview() {
  if (localVideoTrack.value && localInlineVideoEl.value) {
    try {
      localVideoTrack.value.detach(localInlineVideoEl.value);
    } catch (error) {
      console.warn('detachLocalInlinePreview failed', error);
    }
  }
  if (localInlineVideoEl.value) {
    try {
      localInlineVideoEl.value.srcObject = null;
      localInlineVideoEl.value.removeAttribute('src');
      localInlineVideoEl.value.load();
    } catch (error) {
      console.warn('clear inline preview failed', error);
    }
  }
}

function attachLocalVideoPreview(track) {
  if (!track) return;
  // Haupt-Preview (Normalansicht)
  if (localVideoEl.value && !presentationViewStarted.value) {
    try {
      track.detach(localVideoEl.value);
    } catch (_) {
      /* ignore */
    }
    track.attach(localVideoEl.value);
    videoIsRunning.value = true;
  }
  // Inline-Preview (Präsentationsansicht)
  if (presentationViewStarted.value && localInlineVideoEl.value) {
    try {
      track.detach(localInlineVideoEl.value);
    } catch (_) {
      /* ignore */
    }
    track.attach(localInlineVideoEl.value);
  }
  // Admin-Container aktualisieren
  const adminVideoContainer = document.getElementById('local-video');
  if (adminVideoContainer) {
    adminVideoContainer.innerHTML = '';
    const videoElement = track.attach();
    videoElement.style.width = '100%';
    videoElement.style.height = '100%';
    videoElement.style.objectFit = 'cover';
    videoElement.style.borderRadius = '0';
    adminVideoContainer.appendChild(videoElement);
  }
}

function attachLocalInlinePreview() {
  if (!showInlineTeacherPreview.value) return;
  if (!localVideoTrack.value || !localInlineVideoEl.value) return;
  try {
    // Ensure track is not attached multiple times
    localVideoTrack.value.detach(localInlineVideoEl.value);
  } catch (error) {
    // ignore detach errors before attach
  }
  try {
    localVideoTrack.value.attach(localInlineVideoEl.value);
    const el = localInlineVideoEl.value;
    el.muted = true;
    el.playsInline = true;
    el.autoplay = true;
    el.controls = false;
  } catch (error) {
    console.warn('attachLocalInlinePreview failed', error);
  }
}

watch(showInlineTeacherPreview, async (active) => {
  if (active && localVideoTrack.value) {
    await nextTick();
    attachLocalInlinePreview();
  } else {
    detachLocalInlinePreview();
  }
}, { immediate: true });

watch(localVideoTrack, async (track) => {
  if (track && showInlineTeacherPreview.value) {
    await nextTick();
    attachLocalInlinePreview();
  } else {
    detachLocalInlinePreview();
  }
});

watch(presentationViewStarted, async (isPresenting, wasPresenting) => {
  // Nur reagieren wenn von Präsentation zurück zu Normal gewechselt wird
  if (wasPresenting && !isPresenting) {
    console.log('🔄 Präsentation beendet → Video wird wieder im Haupt-Element angezeigt');
    
    // Warte auf DOM-Update
    await nextTick();
    
    // Warte nochmal kurz, um sicherzustellen dass Vue fertig gerendert hat
    setTimeout(async () => {
      if (localVideoTrack.value && localVideoEl.value) {
        try {
          // Zuerst vom Inline-Element detachen
          const inlineEl = document.querySelector('.teacher-inline-preview-video');
          if (inlineEl) {
            localVideoTrack.value.detach(inlineEl);
            console.log('✅ Video vom Inline-Element detached');
          }
          
          // Dann am Haupt-Element attachen
          localVideoTrack.value.attach(localVideoEl.value);
          console.log('✅ Video im Haupt-Element angezeigt');
        } catch (error) {
          console.warn('⚠️ Fehler beim Reattach des Videos:', error);
        }
      } else {
        console.warn('⚠️ localVideoTrack oder localVideoEl nicht verfügbar:', {
          hasTrack: !!localVideoTrack.value,
          hasEl: !!localVideoEl.value
        });
      }
    }, 100);
  }
});

onUnmounted(() => {
  detachLocalInlinePreview();
});

function updatePublishFlags() {
  try {
    const lp = room.value?.localParticipant;
    if (!lp) {
      isVideoPublished.value = false;
      isAudioPublished.value = false;
      return;
    }
    const hasVideo = Array.from(lp.videoTracks?.values?.() || []).some(p => !!p.track);
    const hasAudio = Array.from(lp.audioTracks?.values?.() || []).some(p => !!p.track);
    isVideoPublished.value = hasVideo;
    isAudioPublished.value = hasAudio;
  } catch (e) {
    console.warn('updatePublishFlags failed', e);
  }
}

// Debug-Funktion für Status
function logPublishStatus() {
  console.log('📊 Publish Status:', {
    isVideoPublished: isVideoPublished.value,
    isAudioPublished: isAudioPublished.value,
    hasLocalVideoTrack: !!localVideoTrack.value,
    hasLocalAudioTrack: !!localAudioTrack.value,
    videoIsRunning: videoIsRunning.value,
    webinarStarted: webinarStarted.value
  });
}

// DataTrack Anzeige
const dataTrackMessages = ref([])
const testMessage = ref('')

// User-Chat
const showUserChat = ref(true)
const chatMessages = ref([])
const chatInput = ref('')
const chatMessagesContainer = ref(null)

// Preloading Management - Videos und Bilder nur bei Bedarf laden
function preloadUpcomingSlides() {
  const currentIndex = numberPictureBroadCast.value;
  
  // Lade die nächsten 3 Slides vor (Videos und Bilder)
  for (let i = currentIndex + 1; i <= Math.min(currentIndex + 10, countSlides.value); i++) {
    const slide = pictureBroadCast.value[i];
    if (slide) {
      if (slide.type === 'video' && !preloadedVideos.value.has(slide.url)) {
        console.log('🎬 Preloading video:', slide.url);
        preloadedVideos.value.add(slide.url);
      } else if (slide.type === 'picture' && !preloadedImages.value.has(slide.url)) {
        console.log('🖼️ Preloading image:', slide.url);
        preloadedImages.value.add(slide.url);
      }
    }
  }
}

async function getWebinarStats() {
  console.log('getWebinarStats');
  try {
    let data = {
      action: 'getWebinarStats',
      id: terminData.value.wter_id,
    }
    const response = await baseCalls.webinarPost(data);
    if (response.data.success == true) {
      webinarStats.value = response.data.stats; 
    }
  } catch (error) {
    console.error('Fehler beim Laden der Fragen:', error);
    if (error.code === 'NETWORK_ERROR' || error.message === 'Network Error') {
      console.log('Netzwerkfehler - versuche später erneut');
      // Optional: Benachrichtigung für den User
    }
  }
}

// Reaktions-Animation über Admin-Video anzeigen
function showReactionAnimation(type) {
  let icon = '';
  let color = '';
  
  switch(type) {
    case 'userDanke':
      icon = 'mdi-heart';
      color = '#F44336'; // rot
      break;
    case 'userInteressant':
      icon = 'mdi-fire';
      color = '#FF9800'; // orange
      break;
    case 'neueUserFragen':
      icon = 'mdi-help-circle';
      color = '#2196F3'; // blau
      break;
    case 'userHallo':
      icon = 'mdi-human-greeting';
      color = '#2196F3'; // blau
      break;
  }
  
  // Animation einblenden
  reactionAnimation.value = {
    visible: true,
    icon: icon,
    color: color
  };
  
  // Nach 1 Sekunde wieder ausblenden
  setTimeout(() => {
    reactionAnimation.value.visible = false;
  }, 2000);
}

// function onVideoLoaded() {
//   console.log('Video wurde geladen und ist bereit zum Abspielen');
// }
function getNameFromTeilnehmer(identity,what = 'name') {
  if(audience.value.length > 0) {
    // Extrahiert die Nummer nach dem Unterstrich: "audience_282" -> "282"
    const parts = identity.split('_');
    const id = parts[parts.length - 1]; // Nimmt das letzte Element nach dem Split
    console.log('getNameFromTeilnehmer', identity, '->', id);
    if(what == 'name') {
      return audience.value.find(item => item.wteil_id == id)?.wteil_pers_name || identity;
    }
    if(what == 'admin') {
      return audience.value.find(item => item.wteil_id == id)?.wteil_is_admin || false;
    }
  }
  return identity;
}

function getTimeAgo(timestamp) {
  const now = Date.now();
  const diff = now - timestamp;
  const minutes = Math.floor(diff / 60000);
  
  if (minutes < 1) return 'gerade eben';
  if (minutes === 1) return 'vor 1 Minute';
  if (minutes < 60) return `vor ${minutes} Minuten`;
  
  const hours = Math.floor(minutes / 60);
  if (hours === 1) return 'vor 1 Stunde';
  if (hours < 24) return `vor ${hours} Stunden`;
  
  const days = Math.floor(hours / 24);
  if (days === 1) return 'vor 1 Tag';
  return `vor ${days} Tagen`;
}

function formatTime(timestamp) {
  const date = new Date(timestamp);
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${hours}:${minutes}`;
}


function setPictureBroadCast(number,direction) {
  console.log('setPictureBroadCast', number, direction);
  const slides = currentWebinarSlides.value;
  
  if (direction == 'plus') {
    activePictureBroadCast.value = slides[numberPictureBroadCast.value + 1]
    numberPictureBroadCast.value = numberPictureBroadCast.value + 1
    nextSlide.value = slides[numberPictureBroadCast.value + 1]
  }
  if (direction == 'minus') {
    activePictureBroadCast.value = slides[numberPictureBroadCast.value - 1]
    numberPictureBroadCast.value = numberPictureBroadCast.value - 1
    nextSlide.value = slides[numberPictureBroadCast.value + 1]
  }
  
  // Video automatisch starten wenn es ein Video-Slide ist
  setTimeout(() => {
    if (activePictureBroadCast.value.type === 'video' && currentVideo.value) {
      currentVideo.value.play().catch(console.error);
    }
  }, 100);
  
  sendDataMessage({ type: 'pictureBroadCast', picture: activePictureBroadCast.value, from: 'admin_'+wteiId.value, ts: Date.now() });
}

async function startScreenCapture() {
  try {
    console.log('startScreenCapture: open picker');
    const stream = await navigator.mediaDevices.getDisplayMedia({
      video: { cursor: 'always' },
      audio: false
    });
    console.log('startScreenCapture: stream acquired', {
      videoTracks: stream.getVideoTracks().length,
      audioTracks: stream.getAudioTracks().length
    });

    // Preview im vorhandenen lokalen Video-Element anzeigen
    if (localVideoEl.value) {
      console.log('startScreenCapture: set local preview to screen stream');
      localVideoEl.value.srcObject = stream;
    }

    // Falls bereits verbunden: bisherigen Track ersetzen und neuen Track publishen
    const [screenTrack] = stream.getVideoTracks();
    if (!screenTrack) { console.warn('startScreenCapture: no screen video track'); return; }

    const screenLocalVideoTrack = new Video.LocalVideoTrack(screenTrack, { name: `screen_${wteiId.value}_video` });

    if (room.value) {
      console.log('startScreenCapture: publishing screen track to room');
      if (localVideoTrack.value) {
        try { room.value.localParticipant.unpublishTrack(localVideoTrack.value); } catch (e) { console.warn('unpublishTrack failed', e); }
        try { localVideoTrack.value.stop(); } catch (e) { console.warn('localVideoTrack.stop failed', e); }
      }
      await room.value.localParticipant.publishTrack(screenLocalVideoTrack);
      updatePublishFlags();
    }

    localVideoTrack.value = markRaw(screenLocalVideoTrack);
    isScreenSharing.value = true;
    isVideoPublished.value = true;
    console.log('startScreenCapture: screen sharing active');

    // Handle: wenn der Nutzer die Freigabe beendet, Video-Track entfernen
    screenTrack.addEventListener('ended', async () => {
      console.log('startScreenCapture: screen sharing ended');
      try {
        if (room.value && localVideoTrack.value) {
          room.value.localParticipant.unpublishTrack(localVideoTrack.value);
        }
        if (localVideoEl.value && localVideoEl.value.srcObject === stream) {
          localVideoEl.value.srcObject = null;
        }
        try { localVideoTrack.value.stop(); } catch (e) { console.warn('stop after screen end failed', e); }
        localVideoTrack.value = null;
        isScreenSharing.value = false;
        isVideoPublished.value = false;
      } catch (e) {
        console.error('Fehler nach ScreenShare-Ende:', e);
      }
    });
  } catch (err) {
    console.error('Fehler beim Erfassen des Bildschirms:', err);
  }
}
async function switchBackToCamera() {
  try {
    console.log('switchBackToCamera: start');
    if (!selectedCameraId.value) {
      console.warn('Keine Kamera ausgewählt');
      return;
    }

    // Neuen Kamera-Track erzeugen
    const newVideoTrack = await createVideoTrackForCamera(selectedCameraId.value);
    if (!newVideoTrack) return;
    console.log('switchBackToCamera: camera track created');

    // Vorschau setzen
    if (localVideoEl.value) {
      try { localVideoEl.value.srcObject = null; } catch (e) { console.warn('clear local video srcObject failed', e); }
    }

    // Falls verbunden: bestehenden Track ersetzen
    if (room.value) {
      console.log('switchBackToCamera: publish camera track');
      if (localVideoTrack.value) {
        try { room.value.localParticipant.unpublishTrack(localVideoTrack.value); } catch (e) { console.warn('unpublishTrack (camera) failed', e); }
        try { localVideoTrack.value.stop(); } catch (e) { console.warn('localVideoTrack.stop (camera) failed', e); }
      }
      await room.value.localParticipant.publishTrack(newVideoTrack);
      updatePublishFlags();
      updatePublishFlags();
    }

    localVideoTrack.value = markRaw(newVideoTrack);
    isScreenSharing.value = false;
    isVideoPublished.value = true;
    console.log('switchBackToCamera: done');
  } catch (e) {
    console.error('Fehler beim Zurückwechseln zur Kamera:', e);
  }
}
async function getVideoDevices() {
  try {
    // Erst Berechtigung anfordern, damit Labels verfügbar sind
    await navigator.mediaDevices.getUserMedia({ video: true });
    
    const devices = await navigator.mediaDevices.enumerateDevices();
    videoDevices.value = devices.filter(device => device.kind === 'videoinput');
    console.log('📷 Verfügbare Kameras:', videoDevices.value);
      selectedCameraId.value = videoDevices.value[0].deviceId;
    // Elgato oder bevorzugte Kamera automatisch auswählen
    // const elgato = videoDevices.value.find(d => /elgato|cam\s*link|epoc|virtual/i.test(d.label));
    // if (elgato) {
    //   selectedCameraId.value = elgato.deviceId;
    //   console.log('🎯 Elgato Kamera automatisch ausgewählt:', elgato.label);
    // } else if (videoDevices.value.length > 0) {
     
    //   console.log('📷 Standard-Kamera ausgewählt:', videoDevices.value[0].label);
    // }
  } catch (error) {
    console.error('❌ Fehler beim Laden der Kameras:', error);
  }
}

async function getAudioDevices() {
  try {
    // Erst alle bestehenden Audio-Streams stoppen (macOS Fix)
    if (localAudioTrack.value) {
      console.log('🔄 Stoppe aktuelles Audio-Track für Device-Refresh...');
      localAudioTrack.value.stop();
    }
    
    // Kurz warten damit macOS das Device freigibt
    await new Promise(resolve => setTimeout(resolve, 500));
    
    // Berechtigung anfordern, damit Labels verfügbar sind
    const tempStream = await navigator.mediaDevices.getUserMedia({ audio: true });
    console.log('🎤 Audio-Berechtigung erhalten, stoppe temp stream...');
    tempStream.getTracks().forEach(track => track.stop());
    
    // Kurz warten nach dem Stoppen
    await new Promise(resolve => setTimeout(resolve, 300));
    
    const devices = await navigator.mediaDevices.enumerateDevices();
    audioDevices.value = devices.filter(device => device.kind === 'audioinput');
    console.log('🎤 Verfügbare Mikrofone:', audioDevices.value);
    console.log('🎤 Detaillierte Device-Info:', audioDevices.value.map(d => ({
      deviceId: d.deviceId,
      label: d.label,
      groupId: d.groupId
    })));
    
    // Aktuelles Device beibehalten oder erstes auswählen
    if (!selectedAudioDevice.value && audioDevices.value.length > 0) {
      selectedAudioDevice.value = audioDevices.value[0].deviceId;
      console.log('🎤 Standard-Mikrofon ausgewählt:', audioDevices.value[0].label);
    }
    
    // Prüfen ob aktuell ausgewähltes Device noch verfügbar ist
    const currentDevice = audioDevices.value.find(d => d.deviceId === selectedAudioDevice.value);
    if (!currentDevice && audioDevices.value.length > 0) {
      console.log('⚠️ Aktuelles Mikrofon nicht mehr verfügbar, wechsle zu:', audioDevices.value[0].label);
      selectedAudioDevice.value = audioDevices.value[0].deviceId;
    }
    
  } catch (error) {
    console.error('❌ Fehler beim Laden der Mikrofone:', error);
    console.error('❌ Error details:', error.name, error.message);
  }
}

async function changeAudioDevice() {
  if (!selectedAudioDevice.value) {
    console.log('❌ Kein Mikrofon ausgewählt');
    return;
  }

  try {
    const selectedDevice = audioDevices.value.find(d => d.deviceId === selectedAudioDevice.value);
    console.log('🎤 Wechsle zu Mikrofon:', selectedDevice?.label || selectedAudioDevice.value);
    
    // Aktuelles Audio-Track stoppen und unpublishen
    if (localAudioTrack.value) {
      console.log('🔇 Stoppe aktuelles Audio-Track...');
      
      if (room.value && room.value.localParticipant) {
        try {
          await room.value.localParticipant.unpublishTrack(localAudioTrack.value);
          console.log('🔇 Altes Audio-Track unpublished');
        } catch (unpublishError) {
          console.warn('⚠️ Unpublish Error (ignoriert):', unpublishError.message);
        }
      }
      
      localAudioTrack.value.stop();
      localAudioTrack.value = null;
    }

    // Kurz warten damit macOS das Device freigibt
    await new Promise(resolve => setTimeout(resolve, 300));

    // Neues Audio-Track mit ausgewähltem Mikrofon erstellen
    console.log('🎤 Erstelle neues Audio-Track mit Device:', selectedAudioDevice.value);
    const audioTrack = await Video.createLocalAudioTrack({
      deviceId: { exact: selectedAudioDevice.value }
    });

    localAudioTrack.value = audioTrack;
    console.log('🎤 Neues Audio-Track erstellt:', {
      enabled: audioTrack.enabled,
      kind: audioTrack.kind,
      mediaStreamTrack: audioTrack.mediaStreamTrack ? {
        label: audioTrack.mediaStreamTrack.label,
        readyState: audioTrack.mediaStreamTrack.readyState
      } : null
    });

    // Neues Audio-Track publishen
    if (room.value && room.value.localParticipant) {
      await room.value.localParticipant.publishTrack(audioTrack);
      console.log('🎤 Neues Audio-Track published');
      updatePublishFlags();
    }

    console.log('✅ changeAudioDevice: erfolgreich abgeschlossen');
  } catch (e) {
    console.error('❌ Fehler beim Wechseln des Mikrofons:', e);
    console.error('❌ Error details:', {
      name: e.name,
      message: e.message,
      selectedDevice: selectedAudioDevice.value
    });
    
    // Fallback: Versuche Audio komplett neu zu starten
    console.log('🔄 Versuche Audio-Neustart...');
    try {
      await startLocalAudio();
    } catch (fallbackError) {
      console.error('❌ Audio-Neustart auch fehlgeschlagen:', fallbackError);
    }
  }
}

async function resetAudio() {
  console.log('🔄 Audio Reset gestartet...');
  
  try {
    // 1. Alle Audio-Tracks stoppen
    if (localAudioTrack.value) {
      console.log('🔇 Stoppe aktuelles Audio-Track...');
      if (room.value && room.value.localParticipant) {
        try {
          await room.value.localParticipant.unpublishTrack(localAudioTrack.value);
        } catch (e) {
          console.warn('⚠️ Unpublish beim Reset ignoriert:', e.message);
        }
      }
      localAudioTrack.value.stop();
      localAudioTrack.value = null;
    }
    
    // 2. Audio-Devices zurücksetzen
    audioDevices.value = [];
    selectedAudioDevice.value = '';
    
    // 3. Warten damit macOS alles freigibt
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // 4. Neue Audio-Devices laden
    await getAudioDevices();
    
    // 5. Audio neu starten wenn ein Device verfügbar ist
    if (selectedAudioDevice.value) {
      console.log('🎤 Starte Audio mit neuem Device...');
      await startLocalAudio();
      console.log('✅ Audio Reset erfolgreich abgeschlossen');
    } else {
      console.warn('⚠️ Kein Audio-Device nach Reset verfügbar');
    }
    
    updatePublishFlags();
    
  } catch (error) {
    console.error('❌ Audio Reset fehlgeschlagen:', error);
  }
}

async function startLocalAudio() {
  try {
    console.log('🎤 Starte lokales Audio...');
    
    // Aktuelles Audio-Track stoppen falls vorhanden
    if (localAudioTrack.value) {
      console.log('🔇 Stoppe vorhandenes Audio-Track...');
      localAudioTrack.value.stop();
      localAudioTrack.value = null;
    }
    
    // Audio-Track erstellen mit ausgewähltem Device oder Standard
    const audioConstraints = {
      echoCancellation: true,
      noiseSuppression: true,
      autoGainControl: true,
      name: `teacher_${terminData.value?.id || 'unknown'}_audio`
    };
    
    // Wenn ein spezifisches Device ausgewählt ist
    if (selectedAudioDevice.value) {
      audioConstraints.deviceId = { exact: selectedAudioDevice.value };
      console.log('🎤 Verwende ausgewähltes Mikrofon:', selectedAudioDevice.value);
    }
    
    const audioTrack = await Video.createLocalAudioTrack(audioConstraints);
    localAudioTrack.value = markRaw(audioTrack);
    
    console.log('🎤 Lokales Audio-Track erstellt:', {
      enabled: audioTrack.enabled,
      kind: audioTrack.kind,
      name: audioTrack.name,
      mediaStreamTrack: audioTrack.mediaStreamTrack ? {
        label: audioTrack.mediaStreamTrack.label,
        readyState: audioTrack.mediaStreamTrack.readyState
      } : null
    });
    
    // Audio-Track publishen wenn in einer Room
    if (room.value && room.value.localParticipant) {
      await room.value.localParticipant.publishTrack(audioTrack);
      console.log('🎤 Audio-Track published');
      updatePublishFlags();
    }
    
    return audioTrack;
    
  } catch (error) {
    console.error('❌ Fehler beim Starten des lokalen Audios:', error);
    localAudioTrack.value = null;
    throw error;
  }
}

async function refreshMediaPermissions() {
  if (!navigator.permissions || !navigator.permissions.query) {
    mediaPermissionStatus.value = { camera: 'unbekannt', microphone: 'unbekannt' };
    return;
  }
  try {
    const cameraStatus = await navigator.permissions.query({ name: 'camera' });
    mediaPermissionStatus.value.camera = cameraStatus.state || 'unbekannt';
    cameraStatus.onchange = () => {
      mediaPermissionStatus.value.camera = cameraStatus.state || 'unbekannt';
    };
  } catch (e) {
    mediaPermissionStatus.value.camera = 'unbekannt';
  }
  try {
    const micStatus = await navigator.permissions.query({ name: 'microphone' });
    mediaPermissionStatus.value.microphone = micStatus.state || 'unbekannt';
    micStatus.onchange = () => {
      mediaPermissionStatus.value.microphone = micStatus.state || 'unbekannt';
    };
  } catch (e) {
    mediaPermissionStatus.value.microphone = 'unbekannt';
  }
}

async function changeCamera() {
  if (!selectedCameraId.value) {
    console.warn('❌ Keine Kamera ausgewählt');
    return;
  }
  
  try {
    const selectedDevice = videoDevices.value.find(d => d.deviceId === selectedCameraId.value);
    console.log('🔄 Kamera wird gewechselt zu:', selectedDevice?.label || selectedCameraId.value);
    
    // Fall 1: Room ist verbunden - Live-Wechsel
    if (room.value && localVideoTrack.value) {
      console.log('🔄 Live-Kamerawechsel während Verbindung');
      
      // Alten Video-Track stoppen und unpublizieren
      room.value.localParticipant.unpublishTrack(localVideoTrack.value);
      localVideoTrack.value.stop();
      localVideoTrack.value = null;
      isVideoPublished.value = false;
      
      // Neuen Video-Track erstellen und publizieren
      const newVideoTrack = await createVideoTrackForCamera(selectedCameraId.value);
      if (newVideoTrack) {
        localVideoTrack.value = markRaw(newVideoTrack);
        await room.value.localParticipant.publishTrack(newVideoTrack);
        isVideoPublished.value = true;
        
        // Video im lokalen Element anzeigen
        if (localVideoEl.value) {
          newVideoTrack.attach(localVideoEl.value);
          videoIsRunning.value = true;
        }
        
        // Video AUCH im Admin-Container aktualisieren
        const adminVideoContainer = document.getElementById('local-video');
        if (adminVideoContainer) {
          // Alte Video-Elemente entfernen
          adminVideoContainer.innerHTML = '';
          // Neues Video-Element hinzufügen
          const videoElement = newVideoTrack.attach();
          videoElement.style.width = '100%';
          videoElement.style.height = '100%';
          videoElement.style.objectFit = 'cover';
          videoElement.style.borderRadius = '0';
          adminVideoContainer.appendChild(videoElement);
          console.log('✅ Video im Admin-Container aktualisiert');
        }
      }
    }
    // Fall 2: Noch nicht verbunden - Kamera für späteren Start vormerken
    else {
      console.log('🔄 Kamera für nächsten Start vorgemerkt');
      
      // Eventuell vorhandene lokale Tracks stoppen
      if (localVideoTrack.value) {
        localVideoTrack.value.stop();
        localVideoTrack.value = null;
        isVideoPublished.value = false;
      }
      
      // Neuen Video-Track erstellen für Vorschau
      const newVideoTrack = await createVideoTrackForCamera(selectedCameraId.value);
      if (newVideoTrack) {
        localVideoTrack.value = markRaw(newVideoTrack);
        
        // Video im lokalen Element anzeigen (Vorschau)
        if (localVideoEl.value) {
          newVideoTrack.attach(localVideoEl.value);
          videoIsRunning.value = true;
        }
        
        // Video AUCH im Admin-Container anzeigen (Vorschau)
        const adminVideoContainer = document.getElementById('local-video');
        if (adminVideoContainer) {
          // Alte Video-Elemente entfernen
          adminVideoContainer.innerHTML = '';
          // Neues Video-Element hinzufügen
          const videoElement = newVideoTrack.attach();
          videoElement.style.width = '100%';
          videoElement.style.height = '100%';
          videoElement.style.objectFit = 'cover';
          videoElement.style.borderRadius = '0';
          adminVideoContainer.appendChild(videoElement);
          console.log('✅ Video-Vorschau im Admin-Container angezeigt');
        }
      }
    }
    
    console.log('✅ Kamera erfolgreich gewechselt');
  } catch (error) {
    console.error('❌ Fehler beim Kamerawechsel:', error);
  }
}

// Hilfsfunktion: Video-Track für spezifische Kamera erstellen
async function createVideoTrackForCamera(deviceId) {
  const selectedDevice = videoDevices.value.find(d => d.deviceId === deviceId);
  const isElgato = selectedDevice && /elgato|cam\s*link|epoc|virtual/i.test(selectedDevice.label);
  
  console.log('📷 Erstelle Video-Track - Ist Elgato:', isElgato);
  
  try {
    const videoTrack = await Video.createLocalVideoTrack({
      deviceId: { exact: deviceId },
      width: { ideal: isElgato ? 1920 : 1280, max: isElgato ? 1920 : 1280 },
      height: { ideal: isElgato ? 1080 : 720, max: isElgato ? 1080 : 720 },
      frameRate: { ideal: isElgato ? 25 : 30, max: isElgato ? 25 : 30 },
      name: `teacher_${terminData.value.id}_video`
    });
    
    console.log('🎬 Video-Track erstellt:', {
      width: isElgato ? 1920 : 1280,
      height: isElgato ? 1080 : 720,
      frameRate: isElgato ? 25 : 30,
      device: selectedDevice?.label
    });
    
    return videoTrack;
  } catch (error) {
    console.error('❌ Fehler beim Erstellen des Video-Tracks:', error);
    return null;
  }
}

// async function startBackupDialog() {
//   const confirmed = confirm('⚠️ ACHTUNG: Möchten Sie den Backup Dialog wirklich öffnen?\n\nAlle Teilnehmer werden disconnected!');
//   if (!confirmed) {
//     console.log('❌ Backup Dialog abgebrochen');
//     return;
//   }
//   sendDataMessage({ type: 'startBackupDialog', from: 'admin_'+wteiId.value, ts: Date.now() });
// }

// Fragen Overlay Drag Funktionen
function startFragenDrag(event) {
  fragenIsDragging.value = true;
  fragenDragStart.value = {
    x: event.clientX - fragenOverlayPosition.value.x,
    y: event.clientY - fragenOverlayPosition.value.y
  };
  
  document.addEventListener('mousemove', handleFragenDrag);
  document.addEventListener('mouseup', stopFragenDrag);
  event.preventDefault();
}

function handleFragenDrag(event) {
  if (!fragenIsDragging.value) return;
  
  fragenOverlayPosition.value = {
    x: Math.max(0, Math.min(window.innerWidth - 400, event.clientX - fragenDragStart.value.x)),
    y: Math.max(0, Math.min(window.innerHeight - 200, event.clientY - fragenDragStart.value.y))
  };
}

function stopFragenDrag() {
  fragenIsDragging.value = false;
  document.removeEventListener('mousemove', handleFragenDrag);
  document.removeEventListener('mouseup', stopFragenDrag);
}

function toggleFragenOverlay() {
  fragenOverlayMinimized.value = !fragenOverlayMinimized.value;
}

function toggleFragenOverlayVisibility() {
  fragenOverlayVisible.value = !fragenOverlayVisible.value;
  // Wenn geöffnet wird, aus minimiert-Zustand holen
  if (fragenOverlayVisible.value && fragenOverlayMinimized.value) {
    fragenOverlayMinimized.value = false;
  }
}

// Active Fragen Overlay Drag Funktionen
function startActiveFragenDrag(event) {
  activeFragenIsDragging.value = true;
  activeFragenDragStart.value = {
    x: event.clientX - activeFragenOverlayPosition.value.x,
    y: event.clientY - activeFragenOverlayPosition.value.y
  };
  
  document.addEventListener('mousemove', handleActiveFragenDrag);
  document.addEventListener('mouseup', stopActiveFragenDrag);
  event.preventDefault();
}

function handleActiveFragenDrag(event) {
  if (!activeFragenIsDragging.value) return;
  
  activeFragenOverlayPosition.value = {
    x: Math.max(0, Math.min(window.innerWidth - 500, event.clientX - activeFragenDragStart.value.x)),
    y: Math.max(0, Math.min(window.innerHeight - 200, event.clientY - activeFragenDragStart.value.y))
  };
}

function stopActiveFragenDrag() {
  activeFragenIsDragging.value = false;
  document.removeEventListener('mousemove', handleActiveFragenDrag);
  document.removeEventListener('mouseup', stopActiveFragenDrag);
}

function toggleActiveFragenOverlay() {
  activeFragenOverlayMinimized.value = !activeFragenOverlayMinimized.value;
}

// eslint-disable-next-line no-unused-vars
async function runDiagnostics() {
  try {
    // 📷 Kamera-Test
    const cameraReport = await testVideoInputDevice({
      duration: 5000, // ms, optional
    });
    console.log('📷 Camera Test Result:', cameraReport);

    // 🎤 Audioeingabe-Test
    const audioReport = await testAudioInputDevice({
      duration: 5000, // ms, optional
    });
    console.log('🎤 Audio Input Test Result:', audioReport);

    return { cameraReport, audioReport };
  } catch (error) {
    console.warn('⚠️ Diagnostics fehlgeschlagen (kann ignoriert werden):', error.message);
    // Nicht neu werfen - Diagnostics sind optional
    return null;
  }
}
async function saveActiveFrage(teilnehmerid = 0) {
  let data = {
    action: 'saveActiveFrage',
    teilnehmerid: teilnehmerid,
    id: terminData.value.wter_id,
  }
  await baseCalls.webinarPost(data);
 
}

async function endWebinar() {
  let data = {
    action: 'endWebinar',
    id: terminData.value.wter_id,
 
  }

  console.log('endWebinarDB', data);
  await baseCalls.webinarPost(data);
  console.log('🔚 Webinar wird beendet - Alle Teilnehmer werden disconnected');
  
  try {
    // 1. Alle Teilnehmer über DataTrack zum Disconnect auffordern
    if (room.value && room.value.participants) {
      const participants = Array.from(room.value.participants.values());
      console.log(`📤 Sende Disconnect-Signal an ${participants.length} Teilnehmer`);
      loaderStore.setLoader(true, "Das Webinar wurde beendet...");
      participants.forEach(participant => {
        if (participant.identity.startsWith('audience_')) {
          const disconnectMessage = {
            type: 'forceDisconnect',
            reason: 'Webinar beendet',
            from: `admin_${wteiId.value}`,
            to: participant.identity,
            ts: Date.now()
          };
          sendDataMessage(disconnectMessage);
          console.log(`📤 Disconnect-Signal an ${participant.identity} gesendet`);
        }
      });
    }

    // 2. Kurz warten, damit die Nachrichten ankommen
    await new Promise(resolve => setTimeout(resolve, 2000));

    // 3. Eigene Verbindung beenden
    if (room.value) {
      console.log('🔌 Beende eigene Room-Verbindung');
      room.value.disconnect();
    }

    // 4. Lokale Variablen zurücksetzen
    isConnected.value = false;
    webinarStarted.value = false;
    room.value = null;
    videoIsRunning.value = false;
    terminData.value.beendet = true;
    isOpen.value = false;

    // 5. Backend über Webinar-Ende informieren
    try {
      const data = {
        action: 'endWebinar',
        id: terminData.value.wter_id,
        admin: 1
      };
      const response = await baseCalls.webinarPost(data);
      if (response.data.success) {
        console.log('✅ Backend über Webinar-Ende informiert');
      }
    } catch (error) {
      console.warn('⚠️ Fehler beim Informieren des Backends:', error);
    }

    console.log('✅ Webinar erfolgreich beendet');
    alert('✅ Webinar wurde erfolgreich beendet!\n\nAlle Teilnehmer wurden disconnected.');

  } catch (error) {
    console.error('❌ Fehler beim Beenden des Webinars:', error);
    alert('❌ Fehler beim Beenden des Webinars. Bitte versuchen Sie es erneut.');
  }
}

async function handleEndWebinarClick() {
  if (!showEndWebinarConfirm.value) {
    showEndWebinarConfirm.value = true;
    confirmEndWebinar.value = false;
    return;
  }
  
  if (!confirmEndWebinar.value) {
    console.warn('Bestätigung nicht gesetzt – Webinar wird nicht beendet.');
    return;
  }

  await executeEndWebinar();
}

function confirmEndWebinarChanged(val) {
  confirmEndWebinar.value = val;
  if (val) {
    executeEndWebinar();
  }
}

async function executeEndWebinar() {
  try {
    await endWebinar();
  } finally {
    confirmEndWebinar.value = false;
    showEndWebinarConfirm.value = false;
  }
}
async function reConnect() {
  countReconnects.value = countReconnects.value + 1;
  if (countReconnects.value > 3) {
    console.log('❌ Fehler beim Reconnect');
    return;
  }
  if (token.value != null) {
    room.value = null;
    isConnected.value = false;
    getTokenDirect();
  }
  getFragen();
  getAudience();
}
const isOpen = computed(() => {
  if(!terminData.value){
    return false;
  }
  if (terminData.value.beendet == 1) {
    return false;
  }
  if (terminData.value.open == false) {
    return false;
  }
    // Parse the wter_beginn string into a Date object
    const wterBeginnDate = new Date(terminData.value.wter_beginn);

    // Get the current time
    const now = new Date();

    // Calculate the start and end of the range
    const startRange = new Date(wterBeginnDate);
    startRange.setMinutes(startRange.getMinutes() - 10);

    const endRange = new Date(wterBeginnDate);
    endRange.setMinutes(endRange.getMinutes() + 180);
    console.log(now > startRange && now < endRange);
    // Check if the current time is within the range
    return true;

    //return now > startRange && now < endRange;
});



async function SetStatusFrage(status,item) {
  let data = {
    action: 'setStatusFrage',
    id: item.id,
    status: status,
  }
  const response = await baseCalls.webinarPost(data);
  if (response.data.success == true) {
    getFragen();
  }
}
async function getFragen() {
  console.log('getFragen');
  try {
    let data = {
      action: 'getFragen',
      id: terminData.value.wter_id,
    }
    const response = await baseCalls.webinarPost(data);
    if (response.data.success == true) {
      fragen.value = response.data.fragen;
    }
  } catch (error) {
    console.error('Fehler beim Laden der Fragen:', error);
    if (error.code === 'NETWORK_ERROR' || error.message === 'Network Error') {
      console.log('Netzwerkfehler - versuche später erneut');
      // Optional: Benachrichtigung für den User
    }
  }
}

async function getAudience() {
  try {
    let data = {
      action: 'getAudienceAll',
      id: terminData.value.wter_id,
    }
    console.log('getAudience', data)
    const response = await baseCalls.webinarPost(data);

    if (response.data.success == true) {
      audience.value = response.data.audience;
    }
  } catch (error) {
    console.error('Fehler beim Laden der Audience:', error);
    if (error.code === 'NETWORK_ERROR' || error.message === 'Network Error') {
      console.log('Netzwerkfehler beim Laden der Audience');
    }
  }
}
async function getTerminData() {
  let data = {
    action: 'getTerminData',
    id:  route.params.teilnahmeid,
    hash: route.params.hash,
  }

  const response = await baseCalls.webinarPost(data);
  console.log('getTerminData' ,response.data)
  if (response.data.success == true) {
    terminData.value = response.data.terminData;
    if (response.data.user) {
      userStore.setUser(response.data.user);
    }
    if(terminData.value.open == false) {
      console.log('Webinar ist nicht offen');
      return;
    }
  
    slideShowNumber.value = terminData.value.wter_webinar_id;
    countSlides.value = terminData.value.webi_pres_slides;
    
 
    getAudience();
    getFragen();
    startSession();
    getWebinarStats();
  }
}
async function showInlineVideo(identity) {
  sendDataMessage({ type: 'showInlineVideo', identity: identity, ts: Date.now() });
}
async function hideInlineVideo() {
  sendDataMessage({ type: 'hideInlineVideo', ts: Date.now() });
}
const currentInlineVideoIdentity = ref(null);
function toggleInlineVideo(identity) {
  if (currentInlineVideoIdentity.value === identity) {
    hideInlineVideo();
    currentInlineVideoIdentity.value = null;
  } else {
    showInlineVideo(identity);
    currentInlineVideoIdentity.value = identity;
  }
}
async function setUserVideoOnDirect(video,item) {
  console.log('setUserVideoOnDirect');
  console.log( video);
  console.log( item);
  let identity = 'admin_' + wteiId.value;
  let toSend = item.identity;
  lastFrageIdentity.value = toSend;
  if(video == 0) {
    console.log('setUserVideoOFf');
    sendDataMessage({ type: 'videoOff', to: toSend, from: identity, ts: Date.now() })
    
  } 
  if(video == 1) {
    console.log('setUserVideoOn');
    // if (item.identity == 'audience_1504') {
    //   sendDataMessage({ type: 'showInlineVideo', identity: item.identity, ts: Date.now() });
    // }
    sendDataMessage({ type: 'videoOn', to: toSend,name: item.name,from: identity, ts: Date.now() });
    sendDataMessage({ type: 'jetzLiveImWebinar', from: toSend, ts: Date.now() });
  }

}

async function setUserVideoOn(video,item) {
  let identity = 'admin_' + wteiId.value;
  if (lastFrageIdentity.value != '' && lastFrageIdentity.value != 'audience_' + item.teilnehmerid){
    console.log('setUserVideoOff last video', lastFrageIdentity.value);
    sendDataMessage({ type: 'videoOff', to: lastFrageIdentity.value, from: identity, ts: Date.now() });
  }
  loaderStore.setLoader(true, "Bitte warten, VideoStatus wird geändert...");

  let toSend = 'audience_' + item.teilnehmerid;
  lastFrageIdentity.value = toSend;
  if(video == 0) {
    console.log('setUserVideoOFf');
    sendDataMessage({ type: 'videoOff', to: toSend, from: identity, ts: Date.now() });
    AudienceVideoIsRunning.value = false;
    videoContainerClassAudience.value = 'hidden-video-container';
    speakerName.value = '';
    activeFrage.value = false;
    saveActiveFrage(0);
  } 
  if(video == 1) {
    console.log('setUserVideoOn');
    sendDataMessage({ type: 'videoOn', to: toSend,name: item.name,from: identity, ts: Date.now() });
    AudienceVideoIsRunning.value = true;
    videoContainerClassAudience.value = 'video-container';
    speakerName.value = item.name;
    activeFrage.value = item;
    saveActiveFrage(item.teilnehmerid);
  }
  let data = {
    action: 'setUserVideoOn',
    id: item.teilnehmerid,
    video: video,
  }
  const response = await baseCalls.webinarPost(data);
  if (response.data.success == true) {
    getFragen();
    loaderStore.setLoader(false);
  }
}


// Manuelle Aktualisierung der Teilnehmer-Liste (wegen Twilio Proxy-Problemen)
function updateAllTeilnehmerInRoom() {
  if (!room.value || !room.value.participants) {
    allTeilnehmerInRoom.value = [];
    return;
  }
  
  console.log('🔄 === MANUAL UPDATE TEACHER ===');
  
  // Alle Participants als Array sammeln (lokaler + remote)
  const participantsArray = Array.from(room.value.participants.values());
  const allParticipants = [room.value.localParticipant, ...participantsArray];
  
  // Sichere Datenextraktion (ohne Proxy-Probleme)
  allTeilnehmerInRoom.value = allParticipants.map(participant => {
    const participantData = {
      identity: participant.identity,
      sid: participant.sid,
      state: participant.state,
      isLocal: participant === room.value.localParticipant
    };
    
    // Sichere Track-Zählung
    try {
      participantData.videoTracks = participant.videoTracks ? participant.videoTracks.size : 0;
      participantData.audioTracks = participant.audioTracks ? participant.audioTracks.size : 0;
      participantData.dataTracks = participant.dataTracks ? participant.dataTracks.size : 0;
    } catch (error) {
      console.warn('Fehler beim Lesen der Tracks für', participant.identity, error);
      participantData.videoTracks = 0;
      participantData.audioTracks = 0;
      participantData.dataTracks = 0;
    }
    
    return participantData;
  });
  
  console.log('👥 allTeilnehmerInRoom aktualisiert (Teacher):', allTeilnehmerInRoom.value.length, 'Teilnehmer');
  allTeilnehmerInRoom.value.forEach((p, index) => {
    if (p.identity.startsWith('admin_')) {
      console.log('👤 Admin:', p.identity);
    }
    if (p.identity.startsWith('audience_')) {
      console.log('👤 Audience:', p.identity);
    }
    console.log(`  ${index + 1}. ${p.identity} ${p.isLocal ? '(Lokal)' : '(Remote)'} - State: ${p.state}`);
  });
  
  console.log('🔄 === END MANUAL UPDATE TEACHER ===');
}

function logAllParticipants() {
  if (!room.value) {
    console.log('❌ Keine Verbindung zum Raum');
    return;
  }
  
  console.log('🔍 Teilnehmer im Raum:');
  let nr = 1
  room.value.participants.forEach(participant => {
    console.log(`👤 Teilnehmer: ${nr} ${participant.identity}`);
   
    participant.tracks.forEach(publication => {
      if (publication.isSubscribed) {
        const track = publication.track;
        console.log(`  🎥 Track: ${nr}: ${track.kind}, SID: ${track.sid}`);
      } else {
        console.log(`  🚫 Track nicht abonniert: ${nr}: ${publication.trackSid}`);
      }
    });
    nr++;
  });

  // Lokaler Teilnehmer
  console.log(`👤 Lokaler Teilnehmer: ${room.value.localParticipant.identity}`);
  room.value.localParticipant.tracks.forEach(publication => {
    if (publication.track) {
      console.log(`  🎥 Lokaler Track: ${publication.track.kind}, SID: ${publication.track.sid}`);
    }
  });
  // runDiagnostics() deaktiviert - verursacht DOMException Fehler
}
async function startLocalVideo() {
  try {
    // Kameras laden, falls noch nicht geschehen
    if (videoDevices.value.length === 0) {
      await getVideoDevices();
    }
    
    // Ausgewählte Kamera verwenden oder Fallback
    const deviceId = selectedCameraId.value || videoDevices.value[0]?.deviceId;
    
    let videoTrack = null;
    let audioTrack = null;

    if (!deviceId) {
      console.warn('⚠️ Keine Kamera verfügbar - starte ggf. nur Audio');
    } else {
      console.log('🎥 Verwende Kamera:', deviceId);
      // Video-Track mit der ausgewählten Kamera erstellen
      videoTrack = await createVideoTrackForCamera(deviceId);
      if (!videoTrack) {
        console.warn('⚠️ Video-Track konnte nicht erstellt werden - starte ggf. nur Audio');
      }
    }
    
    // Lokales Audio-Track erstellen (unabhängig von Video)
    try {
      audioTrack = await Video.createLocalAudioTrack({
        echoCancellation: true,
        noiseSuppression: true,
        autoGainControl: true,
        name: `teacher_${terminData.value.id}_audio`
      });
    } catch (audioError) {
      console.error('❌ Audio-Track konnte nicht erstellt werden:', audioError);
      audioTrack = null;
    }
    
    if (!videoTrack && !audioTrack) {
      console.error('❌ Weder Video- noch Audio-Track verfügbar');
      return null;
    }
    
    if (videoTrack) {
      localVideoTrack.value = markRaw(videoTrack);
    }
    if (audioTrack) {
      localAudioTrack.value = markRaw(audioTrack);
    }
    
    if (videoTrack) {
      console.log('🎥 Video-Track erstellt:', videoTrack);
    }
    if (audioTrack) {
      console.log('🎤 Audio-Track erstellt:', audioTrack);
    }
    
    // Status setzen - Tracks sind erstellt aber noch nicht publiziert
    // Status wird erst beim Publizieren auf true gesetzt
    
    if (videoTrack) {
      // Video im lokalen Element anzeigen (unterer Bereich)
      if (localVideoEl.value) {
        videoTrack.attach(localVideoEl.value);
        videoIsRunning.value = true;
      } else {
        videoIsRunning.value = false;
      }
      
      // Video AUCH im Admin-Container anzeigen (oberer Bereich)
      const adminVideoContainer = document.getElementById('local-video');
      if (adminVideoContainer) {
        const videoElement = videoTrack.attach();
        videoElement.style.width = '100%';
        videoElement.style.height = '100%';
        videoElement.style.objectFit = 'cover';
        videoElement.style.borderRadius = '0';
        adminVideoContainer.appendChild(videoElement);
        console.log('✅ Video im Admin-Container angezeigt');
      }
    } else {
      videoIsRunning.value = false;
    }
    
    return { videoTrack, audioTrack };
  } catch (error) {
    console.error('Fehler beim Erstellen von Video/Audio-Tracks:', error);
    return null;
  }
}

async function joinRoom() {
  console.log('joinRoom');
  if(isOpen.value == false) {
    console.log('Webinar ist nicht offen');
    return;
  }
  const roomName = 'webinar_' + webinarTerminId.value;
  const identity = 'admin_' + wteiId.value;
  
  console.log('🔗 Verbinde:', roomName, 'als', identity);

  

  const dataTrack = new Video.LocalDataTrack({
        name: 'chat',
        ordered: true,
        reliable: true
      });
  localDataTrack.value = markRaw(dataTrack);
  try {
    // 1. Lokales Video und Audio erstellen
    const tracks = await startLocalVideo();
    
    // 2. Mit Room verbinden (mit Video-/Audio-/Data-Track)
    const tracksToPublish = [localDataTrack.value];
    if (tracks && tracks.videoTrack) {
      tracksToPublish.push(tracks.videoTrack);
      console.log('🎥 Video-Track wird publiziert');
    }
    if (tracks && tracks.audioTrack) {
      tracksToPublish.push(tracks.audioTrack);
      console.log('🎤 Audio-Track wird publiziert');
    }
    
    // const connectedRoom = await Video.connect(token.value, { 
    //   name: roomName,
    //   identity: identity,
    //   tracks: tracksToPublish,
    //   automaticSubscription: true,
    //   dominantSpeaker: false 
    // });

    const connectedRoom = await Video.connect(token.value, { 
      name: roomName,
      identity: identity,
      tracks: tracksToPublish,
      automaticSubscription: true,
      dominantSpeaker: false ,
      preferredVideoCodecs: [{ codec: 'VP8', simulcast: false }],
      bandwidthProfile: { 
        video: { 
          mode: 'collaboration', 
          maxTracks: 6,
          renderDimensions: {
            high: { width: 1280, height: 720 },
            standard: { width: 640, height: 360 },
            low: { width: 320, height: 180 }
          }
        } 
      }
    });
    room.value = markRaw(connectedRoom);
    
    console.log('✅ Erfolgreich verbunden:', room.value);
    isConnected.value = true;

    // Lokalen Publish-Status initial ableiten und Events registrieren
    updatePublishFlags();
    const lp = room.value.localParticipant;
    if (lp && typeof lp.on === 'function') {
      lp.on('trackPublished', (pub) => {
        if (pub.kind === 'video') isVideoPublished.value = true;
        if (pub.kind === 'audio') isAudioPublished.value = true;
      });
      lp.on('trackUnpublished', (pub) => {
        if (pub.kind === 'video') isVideoPublished.value = false;
        if (pub.kind === 'audio') isAudioPublished.value = false;
      });
    }

    // Falls der DataTrack noch nicht veröffentlicht wurde (Sicherheitsnetz)
    if (!getMyDataTrack() && localDataTrack.value) {
      try {
        await room.value.localParticipant.publishTrack(localDataTrack.value);
        console.log('🔄 DataTrack nachträglich veröffentlicht');
      } catch (e) {
        console.warn('Konnte DataTrack nicht veröffentlichen:', e);
      }
    }

    // optional: erste Nachricht über DataTrack senden (verwendet sendDataMessage)
    sendDataMessage({ type: 'neuerUser', from: identity, ts: Date.now() });
    
    // 3. Event-Listener für Remote-Teilnehmer (nur EINMAL registrieren)
    room.value.on('participantConnected', (participant) => {
      console.log('🔗 Participant beigetreten:', participant.identity);
      setupParticipant(participant);
      updateAllTeilnehmerInRoom();
    });
    room.value.on('participantDisconnected', (participant) => {
      console.log('🔌 Participant verlassen:', participant.identity);
      teardownParticipant(participant);
      updateAllTeilnehmerInRoom();
    });
    
    // 4. Bereits vorhandene Teilnehmer verarbeiten
    const participants = Array.from(room.value.participants.values())
    console.log('👤 Bereits vorhandene Teilnehmer:', participants.length)
    
    // Initial allTeilnehmerInRoom aktualisieren
    updateAllTeilnehmerInRoom();
    participants.forEach(participant => {
      console.log('👤 Participant:', participant.identity);
      console.log('📺 Video Tracks:', participant.videoTracks.size);
      console.log('🎤 Audio Tracks:', participant.audioTracks.size);
      console.log('💬 Data Tracks:', participant.dataTracks.size);
      console.log('🔗 Connection State:', participant.state);
      console.log('---');
      setupParticipant(participant);
    })
  
    
  } catch (e) {
    console.error('❌ Verbindungsfehler:', e.code, e.name, e.message);
    isConnected.value = false;
    webinarStarted.value = false;
    room.value = null;
    token.value = '';
    reConnect();
  }
}

function setupParticipant(participant) {
  console.log('👤 Teilnehmer setup:', participant.identity);
  let activeIdentity = 'audience_' + activeFrage.value.teilnehmerid;
  console.log('activeIdentity', activeIdentity);
  // Initialen Broadcast-Status für diesen Teilnehmer bewerten
  evaluateParticipantBroadcastStatus(participant);
  // schon publizierte Tracks
  participant.tracks.forEach(publication => {
    console.log(`📺 Track gefunden: ${publication.trackName}, Kind: ${publication.kind}, Abonniert: ${publication.isSubscribed}`);
    
    if (publication.isSubscribed && publication.track && publication.track.kind === 'video') {
      displayRemoteTrack(publication.track, participant);
    } else if (!publication.isSubscribed) {
      // Track wird automatisch abonniert, nur Event-Listener hinzufügen
      console.log(`🔔 Warte auf Abonnierung von Track: ${publication.trackSid}`);
    }
    
    // Event-Listener für Subscription
    publication.on('subscribed', track => {
      console.log(`✅ Track abonniert: ${track.kind}, SID: ${track.sid}, Identity: ${participant.identity}`);
      if (track.kind === 'video') displayRemoteTrack(track, participant);
      if (track.kind === 'audio') displayRemoteAudioTrack(track, participant);
      if (track.kind === 'data') bindDataTrackEvents(track, participant.identity);
    });
    
    publication.on('unsubscribed', track => {
      console.log(`❌ Track abgemeldet: ${track.kind}, SID: ${track.sid}`);
      if (track.kind === 'video') detachTrack(track);
      if (track.kind === 'audio') detachAudioTrack(track);
    });
  });

  // zukünftige Publikationen
  participant.on('trackPublished', publication => {
    console.log(`📤 Neuer Track publiziert: ${publication.trackName}, Kind: ${publication.kind}`);
    // Event-Listener für neue Publications
    publication.on('subscribed', track => {
      console.log(`✅ Neuer Track abonniert: ${track.kind}, SID: ${track.sid}, Identity: ${participant.identity}`);
      if (track.kind === 'video') displayRemoteTrack(track, participant);
      if (track.kind === 'audio') displayRemoteAudioTrack(track, participant);
      if (track.kind === 'data') bindDataTrackEvents(track, participant.identity);
      evaluateParticipantBroadcastStatus(participant);
    });
  });

  // Track wird nicht mehr publiziert
  participant.on('trackUnpublished', (publication) => {
    console.log('📤 Track unpublished:', publication.kind, 'von', participant.identity);
    if (publication.kind === 'video') {
      // Video entfernen
      removeActiveVideo(participant.identity);
    }
    evaluateParticipantBroadcastStatus(participant);
  });

  participant.on('trackSubscribed', track => {
    console.log(`🎥 Track automatisch abonniert: ${track.kind}, SID: ${track.sid}, Identity: ${participant.identity}`);
    if (track.kind === 'video') displayRemoteTrack(track, participant);
    if (track.kind === 'audio') displayRemoteAudioTrack(track, participant);
    if (track.kind === 'data') bindDataTrackEvents(track, participant.identity);
    evaluateParticipantBroadcastStatus(participant);
  });

  participant.on('trackUnsubscribed', track => {
    console.log(`🚫 Track automatisch abgemeldet: ${track.kind}, SID: ${track.sid}`);
    if (track.kind === 'video') detachTrack(track);
    if (track.kind === 'audio') detachAudioTrack(track);
    evaluateParticipantBroadcastStatus(participant);
  });
}

// Liefert für jeden Teilnehmer (identity) den Broadcast-Status (video/audio/broadcasting/watching)
const participantBroadcastStatusMap = ref(new Map());

function evaluateParticipantBroadcastStatus(participant) {
  try {
    const hasVideo = Array.from(participant.videoTracks?.values?.() || []).some(pub => !!pub.track);
    const hasAudio = Array.from(participant.audioTracks?.values?.() || []).some(pub => !!pub.track);
    const isBroadcasting = hasVideo || hasAudio;
    participantBroadcastStatusMap.value.set(participant.identity, {
      hasVideo,
      hasAudio,
      isBroadcasting
    });
    // Optional: Debug-Ausgabe
    console.log('📡 BroadcastStatus', participant.identity, { hasVideo, hasAudio, isBroadcasting });
  } catch (e) {
    console.warn('evaluateParticipantBroadcastStatus failed for', participant.identity, e);
  }
}

// Helper zum Abrufen als Plain-Objekt-Liste (z. B. für UI)
function getParticipantsBroadcastStatus() {
  const list = [];
  if (!room.value) return list;
  // Remote participants
  room.value.participants.forEach(p => {
    const status = participantBroadcastStatusMap.value.get(p.identity) || { hasVideo: false, hasAudio: false, isBroadcasting: false };
    list.push({ identity: p.identity, ...status });
  });
  // Local participant
  const lp = room.value.localParticipant;
  if (lp) {
    const status = {
      hasVideo: Array.from(lp.videoTracks?.values?.() || []).some(pub => !!pub.track),
      hasAudio: Array.from(lp.audioTracks?.values?.() || []).some(pub => !!pub.track)
    };
    list.unshift({ identity: lp.identity, ...status, isBroadcasting: status.hasVideo || status.hasAudio });
  }
  return list;
}


function detachTrack(track) {
  track.detach().forEach(el => el.remove());
}

// Audio Track entfernen
function detachAudioTrack(track) {
  console.log('🎤 Audio Track wird entfernt:', track.sid);
  const audioElements = track.detach();
  audioElements.forEach(el => {
    console.log('🎤 Audio-Element entfernt');
    el.remove();
  });
}

function teardownParticipant(participant) {
  console.log('👤 Teilnehmer entfernt:', participant.identity);
  
  // Video aus activeVideos entfernen
  removeActiveVideo(participant.identity);
}
// Funktion zum Hinzufügen eines Videos zur activeVideos Liste
function addActiveVideo(identity, name, track, participant) {
  try {
    console.log('🔍 addActiveVideo aufgerufen:', {
      identity,
      name,
      trackKind: track.kind,
      participantIdentity: participant.identity,
      activeVideosLength: activeVideos.value.length
    });
    
    // Prüfen ob Video bereits existiert
    const existingIndex = activeVideos.value.findIndex(video => video.identity === identity);
    if (existingIndex !== -1) {
      console.log('🔄 Video bereits aktiv, ersetze:', identity);
      activeVideos.value[existingIndex] = { 
        identity, 
        name, 
        track: markRaw(track), // Verhindert Vue Proxy-Probleme
        participant: markRaw(participant) // Verhindert Vue Proxy-Probleme
      };
    } else {
      console.log('➕ Neues Video hinzugefügt:', identity, name);
      activeVideos.value.push({ 
        identity, 
        name, 
        track: markRaw(track), // Verhindert Vue Proxy-Probleme
        participant: markRaw(participant) // Verhindert Vue Proxy-Probleme
      });
      console.log('📊 ActiveVideos nach Hinzufügen:', activeVideos.value.length);
      console.log('📊 ActiveVideos Array:', activeVideos.value.map(v => `${v.identity}:${v.name}`));
      console.log('📊 Vollständiges ActiveVideos Array:', activeVideos.value);
    }
    
    // Video im DOM anzeigen - mit Verzögerung für Vue-Rendering
    setTimeout(() => {
      displayVideoInContainer(identity, name, track);
    }, 100);
    
  } catch (error) {
    console.error('❌ Fehler beim Hinzufügen des Videos:', error);
    console.error('❌ Error Stack:', error.stack);
  }
}

// Funktion zum Entfernen eines Videos
function removeActiveVideo(identity) {
  try {
    const index = activeVideos.value.findIndex(video => video.identity === identity);
    if (index !== -1) {
      const video = activeVideos.value[index];
      console.log('➖ Video & Audio entfernt:', identity, video.name);
      
      // Aus Array entfernen
      activeVideos.value.splice(index, 1);
      
      // Aus DOM entfernen
      removeVideoFromContainer(identity);

      // Falls keine Videos mehr vorhanden sind, übergeordneten Container ausblenden
      try {
        const listRoot = document.getElementById('audience-videos');
        if (listRoot && activeVideos.value.length === 0) {
          listRoot.style.display = 'none';
          console.log('🧹 audience-videos Container versteckt (leer)');
        }
      } catch (e) { /* noop */ }
      
      // DataMessage senden um Video UND Audio zu beenden
      // sendDataMessage({ 
      //   type: 'videoOff', 
      //   to: identity, 
      //   from: `admin_${terminData.value.id}`, 
      //   ts: Date.now() 
      // });
      
      // // Zusätzliche DataMessage für Audio-Deaktivierung
      // sendDataMessage({ 
      //   type: 'audioOff', 
      //   to: identity, 
      //   from: `admin_${terminData.value.id}`, 
      //   ts: Date.now() 
      // });
      
      console.log('📤 Video & Audio Off Messages gesendet an:', identity);
      
      // Broadcast-Status aktualisieren
      const currentStatus = participantBroadcastStatusMap.value.get(identity) || {};
      participantBroadcastStatusMap.value.set(identity, {
        ...currentStatus,
        hasVideo: false,
        hasAudio: false,
        isBroadcasting: false
      });
      console.log('📊 Broadcast-Status aktualisiert für:', identity, 'Video: false, Audio: false');
      
    }
  } catch (error) {
    console.error('❌ Fehler beim Entfernen des Videos:', error);
  }
}

// Funktion zum Anzeigen eines Videos im Vue-Container
function displayVideoInContainer(identity, name, track) {
  console.log('🎬 displayVideoInContainer aufgerufen:', {
    identity,
    name,
    trackSid: track.sid,
    trackKind: track.kind,
    trackEnabled: track.enabled,
    trackState: track.state,
    mediaStreamTrack: track.mediaStreamTrack ? {
      enabled: track.mediaStreamTrack.enabled,
      readyState: track.mediaStreamTrack.readyState,
      muted: track.mediaStreamTrack.muted
    } : null
  });

  // Vue-Container finden (wird von v-for erstellt)
  const containerID = `video-container-${identity.replace('_', '-')}`;
  console.log('🔍 Suche Container:', containerID);
  
  const vueContainer = document.getElementById(containerID);
  
  if (!vueContainer) {
    console.error('❌ Vue-Container nicht gefunden:', containerID);
    console.log('🔍 Verfügbare Container IDs:', Array.from(document.querySelectorAll('[id^="video-container-"]')).map(el => el.id));
    return;
  }

  console.log('✅ Vue-Container gefunden:', containerID, vueContainer);

  // Video-Bereich innerhalb des Vue-Containers finden (per CSS-Klasse)
  const videoArea = vueContainer.querySelector('.video-area');
  if (!videoArea) {
    console.error('❌ Video-Bereich nicht gefunden in:', containerID);
    console.log('🔍 Container Inhalt:', vueContainer.innerHTML);
    return;
  }

  console.log('✅ Video-Bereich gefunden in Container:', containerID);

  // ALLE existierenden Videos entfernen (auch verwaiste)
  const existingVideos = videoArea.querySelectorAll('video');
  if (existingVideos.length > 0) {
    existingVideos.forEach((video, index) => {
      console.log(`🗑️ Entferne Video ${index + 1}/${existingVideos.length}:`, {
        videoWidth: video.videoWidth,
        videoHeight: video.videoHeight,
        readyState: video.readyState,
        paused: video.paused,
        srcObject: !!video.srcObject
      });
      video.remove();
    });
    console.log(`🗑️ ${existingVideos.length} alte Videos entfernt aus Vue-Container`);
  }

  // Prüfen ob Track überhaupt bereit ist
  if (!track.mediaStreamTrack) {
    console.error('❌ Track hat kein mediaStreamTrack:', identity);
    return;
  }

  if (track.mediaStreamTrack.readyState !== 'live') {
    console.warn('⚠️ Track mediaStreamTrack ist nicht live:', identity, track.mediaStreamTrack.readyState);
  }

  console.log('📹 Erstelle Video Element für Track:', track.sid);

  // KRITISCH: Prüfen ob Track bereits attached ist
  const existingAttachments = track.attachments;
  console.log('🔍 Track Attachments vor attach():', {
    trackSid: track.sid,
    identity: identity,
    existingAttachments: existingAttachments ? existingAttachments.size : 0,
    attachedElements: existingAttachments ? Array.from(existingAttachments).map(el => ({
      tagName: el.tagName,
      parentId: el.parentElement?.id || 'no-parent',
      isConnected: el.isConnected
    })) : []
  });

  // Video Element erstellen
  const videoElement = track.attach();
  console.log('🎥 Video Element erstellt:', {
    identity: identity,
    videoWidth: videoElement.videoWidth,
    videoHeight: videoElement.videoHeight,
    readyState: videoElement.readyState,
    srcObject: !!videoElement.srcObject,
    hasVideoTracks: videoElement.srcObject ? videoElement.srcObject.getVideoTracks().length : 0,
    isConnected: videoElement.isConnected,
    parentElement: videoElement.parentElement?.id || 'no-parent'
  });

  // Nach attach() prüfen
  console.log('🔍 Track Attachments nach attach():', {
    trackSid: track.sid,
    identity: identity,
    attachmentsCount: track.attachments ? track.attachments.size : 0
  });

  // Video Element einfach konfigurieren und starten
  videoElement.style.width = '100%';
  videoElement.style.height = '100%';
  videoElement.style.objectFit = 'cover';
  videoElement.style.backgroundColor = '#000';
  videoElement.autoplay = true;
  videoElement.muted = false;
  videoElement.setAttribute('playsinline', '');
  
  // Video explizit starten - aber erst nach DOM-Attachment
  setTimeout(() => {
    videoElement.play().then(() => {
      console.log('▶️ Video gestartet für:', identity);
    }).catch(error => {
      // Nur loggen wenn Element noch im DOM ist
      if (videoElement.parentElement) {
        console.error('❌ Video konnte nicht gestartet werden:', identity, error);
        } else {
        console.log('ℹ️ Video Play abgebrochen (Element wurde ersetzt):', identity);
      }
    });
  }, 50);
  
  console.log('🎬 Video Element konfiguriert, füge zu Container hinzu...');

  // Video Element zum Container hinzufügen
  videoArea.appendChild(videoElement);
  console.log('✅ Video Element zu Container hinzugefügt');

  // Event Listener für Video-Laden
  videoElement.addEventListener('loadedmetadata', () => {
    console.log('✅ Video Metadaten geladen für:', identity, {
      videoWidth: videoElement.videoWidth,
      videoHeight: videoElement.videoHeight,
      readyState: videoElement.readyState,
      paused: videoElement.paused
    });
    
    // Prüfen ob Video-Dimensionen ungültig sind
    if (videoElement.videoWidth === 0 || videoElement.videoHeight === 0) {
      console.warn('⚠️ Video hat ungültige Dimensionen (0x0) für:', identity);
      console.log('🔄 Track-Status prüfen und reaktivieren...');
      
      // Detaillierte Track-Diagnose
      console.log('🔍 Track-Diagnose für:', identity, {
        trackSid: track.sid,
        trackEnabled: track.enabled,
        trackState: track.state,
        mediaStreamTrack: track.mediaStreamTrack ? {
          readyState: track.mediaStreamTrack.readyState,
          enabled: track.mediaStreamTrack.enabled,
          muted: track.mediaStreamTrack.muted
        } : 'null'
      });
      
      // Fallback: Video-Element mit Placeholder anzeigen
      videoElement.style.background = 'linear-gradient(45deg, #333 25%, #555 25%, #555 50%, #333 50%, #333 75%, #555 75%, #555)';
      videoElement.style.backgroundSize = '20px 20px';
      
      // Overlay mit Info hinzufügen
      const overlay = document.createElement('div');
      overlay.style.cssText = `
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: white;
        text-align: center;
        font-size: 14px;
        z-index: 10;
        background: rgba(0,0,0,0.7);
        padding: 10px;
        border-radius: 0;
      `;
      overlay.innerHTML = `
        <div>📹 Video wird geladen...</div>
        <div style="font-size: 12px; margin-top: 5px;">${name}</div>
        <div style="font-size: 10px; margin-top: 5px; color: #ccc;">Track: ${track.sid}</div>
      `;
      
      // Overlay zum Video-Container hinzufügen
      videoArea.style.position = 'relative';
      videoArea.appendChild(overlay);
      
      console.log('📺 Placeholder-Video mit Info-Overlay erstellt für:', identity);
    }
    
    // Video nochmal starten wenn es pausiert ist
    if (videoElement.paused) {
      console.log('🔄 Video ist pausiert, starte erneut:', identity);
      videoElement.play().catch(error => {
        console.error('❌ Erneuter Video-Start fehlgeschlagen:', identity, error);
      });
    }
  });

  videoElement.addEventListener('loadeddata', () => {
    console.log('✅ Video Daten geladen für:', identity);
    
    // Auch hier nochmal versuchen zu starten
    if (videoElement.paused) {
      console.log('🔄 Video nach Daten-Laden pausiert, starte erneut:', identity);
      videoElement.play().catch(error => {
        console.error('❌ Video-Start nach Daten-Laden fehlgeschlagen:', identity, error);
      });
    }
  });

  videoElement.addEventListener('error', (e) => {
    console.error('❌ Video Fehler für:', identity, e);
  });

  console.log('🎥 Video bereits in Vue-Container eingefügt:', identity, name);
  
  // Zusätzliche Debugging-Info
  setTimeout(() => {
    console.log('🔍 Video Status nach 1s für', identity, ':', {
      videoWidth: videoElement.videoWidth,
      videoHeight: videoElement.videoHeight,
      readyState: videoElement.readyState,
      paused: videoElement.paused,
      muted: videoElement.muted,
      currentTime: videoElement.currentTime,
      duration: videoElement.duration,
      srcObject: !!videoElement.srcObject,
      parentElement: !!videoElement.parentElement,
      style: {
        width: videoElement.style.width,
        height: videoElement.style.height,
        display: videoElement.style.display
      }
    });
    
    // Wenn Video schwarz ist oder 0x0 Dimensionen hat, versuche es erneut zu starten
    if (videoElement.readyState === 0 || videoElement.paused || 
        videoElement.videoWidth === 0 || videoElement.videoHeight === 0) {
      console.log('🔄 Video Problem erkannt für:', identity, {
        readyState: videoElement.readyState,
        paused: videoElement.paused,
        dimensions: `${videoElement.videoWidth}x${videoElement.videoHeight}`
      });
      
      if (videoElement.videoWidth === 0 || videoElement.videoHeight === 0) {
        console.log('🔄 Video hat 0x0 Dimensionen, versuche Track-Neuattachment...');
        try {
          // Prüfen ob Element noch im DOM ist
          if (!videoElement.parentElement) {
            console.log('ℹ️ Video bereits entfernt, überspringe Timeout-Reaktivierung für:', identity);
            return;
          }
          
          const newVideoElement = track.attach();
          newVideoElement.style.width = '280px';
          newVideoElement.style.height = '200px';
          newVideoElement.style.backgroundColor = '#000';
          newVideoElement.autoplay = true;
          newVideoElement.muted = false;
          newVideoElement.setAttribute('playsinline', '');
          
          // Altes Video ersetzen
          videoElement.replaceWith(newVideoElement);
          console.log('🔄 Video-Element durch Timeout ersetzt für:', identity);
          
          // Video starten mit zusätzlichem Delay
          setTimeout(() => {
            if (newVideoElement.parentElement) {
              newVideoElement.play().catch(e => {
                if (newVideoElement.parentElement) {
                  console.error('❌ Timeout Video Start Error:', e);
                }
              });
            }
          }, 200);
        } catch (error) {
          console.error('❌ Timeout Video-Reaktivierung fehlgeschlagen:', identity, error);
        }
      } else if (videoElement.parentElement) {
        videoElement.play().catch(e => {
          if (videoElement.parentElement) {
            console.error('❌ Erneuter Start fehlgeschlagen:', e);
          }
        });
      }
    }
  }, 1000);
}

// Debug-Funktion zum Prüfen der DOM-Container
function checkDOMContainers() {
  const containers = document.querySelectorAll('[id^="video-container-"]');
  const info = [];
  
  info.push(`Gefundene Container: ${containers.length}`);
  
  containers.forEach((container, index) => {
    const videoArea = container.querySelector('.video-area');
    const videoElement = videoArea ? videoArea.querySelector('video') : null;
    
    info.push(`${index + 1}. ID: ${container.id}`);
    info.push(`   - Video-Area: ${videoArea ? 'gefunden' : 'nicht gefunden'}`);
    info.push(`   - Video-Element: ${videoElement ? 'gefunden' : 'nicht gefunden'}`);
    
    if (videoElement) {
      info.push(`   - Video Status: ${videoElement.paused ? 'pausiert' : 'läuft'}`);
      info.push(`   - Video Größe: ${videoElement.videoWidth}x${videoElement.videoHeight}`);
      info.push(`   - SrcObject: ${videoElement.srcObject ? 'vorhanden' : 'fehlt'}`);
      info.push(`   - IsConnected: ${videoElement.isConnected}`);
    }
    info.push('');
  });
  
  info.push(`ActiveVideos Array: ${activeVideos.value.length}`);
  activeVideos.value.forEach((video, index) => {
    const track = video.track;
    info.push(`${index + 1}. ${video.identity} - ${video.name}`);
    info.push(`   - Track SID: ${track.sid}`);
    info.push(`   - Track Enabled: ${track.enabled}`);
    info.push(`   - Track State: ${track.state || 'unknown'}`);
    info.push(`   - Attachments: ${track.attachments ? track.attachments.size : 0}`);
    info.push('');
  });
  
  // Globale Track-Übersicht
  info.push('=== GLOBALE TRACK-ANALYSE ===');
  const allVideoElements = document.querySelectorAll('video');
  info.push(`Alle Video-Elemente im DOM: ${allVideoElements.length}`);
  allVideoElements.forEach((video, index) => {
    info.push(`Video ${index + 1}: ${video.videoWidth}x${video.videoHeight}, ReadyState: ${video.readyState}, Paused: ${video.paused}`);
  });
  
  domContainerInfo.value = info.join('\n');
  console.log('🔍 DOM Container Check:', info.join('\n'));
}

// Funktion zum Entfernen eines Videos aus dem DOM (Vue-basiert)
function removeVideoFromContainer(identity) {
  // Im Vue-basierten System wird das Video automatisch entfernt, 
  // wenn es aus dem activeVideos Array entfernt wird.
  // Diese Funktion ist nur noch für Cleanup von manuell erstellten Elementen nötig.
  
  const containerID = `video-container-${identity.replace('_', '-')}`;
  const existingContainer = document.getElementById(containerID);
  
  if (existingContainer) {
    console.log('🗑️ Video Container entfernt:', containerID);
    existingContainer.remove();
      } else {
    console.log('✅ Kein manueller Container zu entfernen für:', identity, '(Vue managed)');
  }
}

// Remote-Video anzeigen (nur audience_) - VUE-BASIERT
function displayRemoteTrack(track, participant) {
  console.log('🔍 displayRemoteTrack aufgerufen:', {
    trackKind: track.kind,
    participantIdentity: participant.identity,
    trackSid: track.sid
  });
  
  // NEUES SYSTEM: Vue-basiertes Multi-Video-System (kein DOM-Container nötig)
  if (participant.identity.startsWith('audience_') && track.kind === 'video') {
    const participantName = getNameFromTeilnehmer(participant.identity, 'name');
    console.log('🎥 Audience Video hinzufügen:', participant.identity, 'Name:', participantName);
    console.log('🔍 ActiveVideos vor Hinzufügen:', activeVideos.value.length);
    addActiveVideo(participant.identity, participantName, track, participant);
    console.log('🔍 ActiveVideos nach Hinzufügen:', activeVideos.value.length);
  } else {
    console.log('🚫 Track ignoriert:', track.kind, participant.identity);
  }
}

// Remote-Audio anzeigen (nur audience_)
function displayRemoteAudioTrack(track, participant) {
  console.log('🎤 Audio Track empfangen von:', participant.identity);
  console.log('🎯 Audio Track SID:', track.sid);
  
  // Überprüfen, ob das Audio-Element bereits vorhanden ist
  const existingAudio = document.querySelector(`[data-audio-track-id="${track.sid}"]`);
  
  if (!existingAudio) {
    console.log('🎤 Neues Audio-Element wird erstellt');
    const audioElement = track.attach(); // <audio>
    audioElement.autoplay = true; // Audio automatisch abspielen
    audioElement.setAttribute('data-audio-track-id', track.sid);
    audioElement.setAttribute('data-participant-identity', participant.identity);
    audioElement.style.display = 'none'; // Audio-Element verstecken (nur Sound)
    
    // Audio-Element zum Body hinzufügen (unsichtbar)
    document.body.appendChild(audioElement);
    console.log('✅ Audio empfangen von:', participant.identity);
  } else {
    console.log('🎤 Audio-Element bereits vorhanden für Track:', track.sid);
  }
}

// Video-Track publizieren (nachträglich)
async function publishVideo() {
  if (!room.value) {
    console.error('Nicht mit Room verbunden');
    return;
  }
  
  try {
    // Falls noch keine Tracks existieren, erstellen
    if (!localVideoTrack.value || !localAudioTrack.value) {
      const tracks = await startLocalVideo();
      if (tracks) {
        if (tracks.videoTrack) {
          await room.value.localParticipant.publishTrack(tracks.videoTrack);
          console.log('✅ Neues Video erstellt und publiziert');
          isVideoPublished.value = true;
        }
        if (tracks.audioTrack) {
          await room.value.localParticipant.publishTrack(tracks.audioTrack);
          console.log('✅ Neues Audio erstellt und publiziert');
          isAudioPublished.value = true;
        }
      }
    } else {
      // Existierende Tracks publizieren
      if (localVideoTrack.value) {
        await room.value.localParticipant.publishTrack(localVideoTrack.value);
        console.log('✅ Existierendes Video publiziert');
        isVideoPublished.value = true;
      }
      if (localAudioTrack.value) {
        await room.value.localParticipant.publishTrack(localAudioTrack.value);
        console.log('✅ Existierendes Audio publiziert');
        isAudioPublished.value = true;
      }
    }
  } catch (error) {
    console.error('Fehler beim Publizieren:', error);
  }
}

// Video- und Audio-Tracks stoppen
async function unpublishVideo() {
  if (!room.value) return;

  // Video-Track unpublizieren und stoppen
  if (localVideoTrack.value) {
    room.value.localParticipant.unpublishTrack(localVideoTrack.value);
    localVideoTrack.value.stop();
    localVideoTrack.value = null;
    isVideoPublished.value = false;
    console.log('✅ Video-Track gestoppt');
  }
  
  // Audio-Track unpublizieren und stoppen
  if (localAudioTrack.value) {
    room.value.localParticipant.unpublishTrack(localAudioTrack.value);
    localAudioTrack.value.stop();
    localAudioTrack.value = null;
    isAudioPublished.value = false;
    console.log('✅ Audio-Track gestoppt');
  }
  
  // Video-Element im unteren Bereich leeren
  if (localVideoEl.value) {
    localVideoEl.value.srcObject = null;
  }
  
  // Video-Container im Admin-Bereich leeren
  const adminVideoContainer = document.getElementById('local-video');
  if (adminVideoContainer) {
    adminVideoContainer.innerHTML = '';
  }
  
  console.log('✅ Video und Audio gestoppt und aus beiden Containern entfernt');
}

function isLocallyBroadcasting() {
  const lp = room.value?.localParticipant;
  if (!lp) return false;
  const hasVideo = Array.from(lp.videoTracks?.values?.() || []).some(pub => !!pub.track);
  const hasAudio = Array.from(lp.audioTracks?.values?.() || []).some(pub => !!pub.track);
  return hasVideo || hasAudio;
}

async function toggleLocalBroadcast() {
  try {
    if (!room.value) return;
    if (isLocallyBroadcasting()) {
      await unpublishVideo();
    } else {
      await publishVideo();
    }
  } catch (e) {
    console.error('❌ toggleLocalBroadcast Fehler:', e);
  }
}

// Nur Video toggeln (Audio bleibt unverändert)
async function toggleLocalVideoOnly() {
  try {
    if (!room.value) return;
    
    if (isVideoPublished.value && localVideoTrack.value) {
      console.log('🎥 Video AUS (Audio bleibt aktiv)');
      try {
        await room.value.localParticipant.unpublishTrack(localVideoTrack.value);
      } catch (e) {
        console.warn('⚠️ unpublishTrack (Video) fehlgeschlagen:', e);
      }
      try {
        localVideoTrack.value.stop();
      } catch (e) {
        console.warn('⚠️ stop() (Video) fehlgeschlagen:', e);
      }
      localVideoTrack.value = null;
      isVideoPublished.value = false;
      videoIsRunning.value = false;
      
      if (localVideoEl.value) {
        localVideoEl.value.srcObject = null;
      }
      const adminVideoContainer = document.getElementById('local-video');
      if (adminVideoContainer) {
        adminVideoContainer.innerHTML = '';
      }
      updatePublishFlags();
      return;
    }
    
    console.log('🎥 Video AN (Audio bleibt unverändert)');
    const deviceId = selectedCameraId.value || videoDevices.value[0]?.deviceId;
    if (!deviceId) {
      console.warn('⚠️ Keine Kamera verfügbar - Video kann nicht gestartet werden');
      return;
    }
    const newVideoTrack = await createVideoTrackForCamera(deviceId);
    if (!newVideoTrack) {
      console.warn('⚠️ Video-Track konnte nicht erstellt werden');
      return;
    }
    
    localVideoTrack.value = markRaw(newVideoTrack);
    await room.value.localParticipant.publishTrack(newVideoTrack);
    isVideoPublished.value = true;
    videoIsRunning.value = true;
    updatePublishFlags();

    // DOM sicherstellen, dann Video neu attachen (verhindert schwarzen Screen)
    await nextTick();
    setTimeout(() => {
      attachLocalVideoPreview(newVideoTrack);
    }, 100);
  } catch (e) {
    console.error('❌ toggleLocalVideoOnly Fehler:', e);
  }
}

// Webinar Video Streaming Funktionen
// function onWebinarVideoLoaded() {
//   console.log('📹 Webinar Video geladen');
//   webinarVideoReady.value = true;
// }

// Canvas Drawing Funktion nicht mehr benötigt - direkter Video-Stream

async function streamWebinarVideo() {

  if (broadCastWebinar.value == true) {
    console.log('🚫 Webinar Video wird nicht gestreamt, da BroadCastWebinar aktiv ist');
    return;
  }
  try {
    if (!webinarVideoEl.value || !room.value) {
      console.error('❌ Video-Element oder Room nicht verfügbar');
      return;
    }

    // Prüfen ob bereits ein Track existiert (Fortsetzen) oder neu starten
    const isResuming = webinarVideoTrack.value !== null;
    
    if (isResuming) {
      console.log('▶️ Setze pausiertes Webinar Video fort...');
      
      // Video fortsetzen
      if (webinarVideoEl.value.paused) {
        try {
          await webinarVideoEl.value.play();
          console.log('✅ Video fortgesetzt');
        } catch (error) {
          console.error('❌ Fehler beim Fortsetzen des Videos:', error);
        }
      }
      
      // DataTrack Nachricht senden
      sendDataMessage({
        type: 'webinarVideoResumed',
        from: 'webinar_' + route.params.teilnahmeid,
        ts: Date.now()
      });
      
      console.log('✅ Webinar Video fortgesetzt');
      return;
    }

    console.log('📹 Starte neues Webinar Video Stream...');
    
    // Video-Element Status prüfen
    console.log('🎬 Video Element Status:');
    console.log('  - readyState:', webinarVideoEl.value.readyState);
    console.log('  - paused:', webinarVideoEl.value.paused);
    console.log('  - currentTime:', webinarVideoEl.value.currentTime);
    console.log('  - duration:', webinarVideoEl.value.duration);

    // Video sicherstellen, dass es läuft
    if (webinarVideoEl.value.paused) {
      console.log('▶️ Video ist pausiert - starte es...');
      try {
        await webinarVideoEl.value.play();
        console.log('✅ Video gestartet');
      } catch (error) {
        console.error('❌ Fehler beim Starten des Videos:', error);
      }
    }

    // Direkter Video-Stream vom Video-Element (ohne Canvas)
    const mediaStream = webinarVideoEl.value.captureStream();
    const videoTrack = mediaStream.getVideoTracks()[0];
    
    if (!videoTrack) {
      console.error('❌ Kein Video-Track vom Video-Element erhalten');
      return;
    }

    console.log('🎬 Video-Track direkt vom Video-Element erhalten');

  

    // Twilio Video-Track direkt aus Video-Stream erstellen
    webinarVideoTrack.value = markRaw(new Video.LocalVideoTrack(videoTrack, {
      name: 'webinar-video'
    }));

    // Track publishen
    await room.value.localParticipant.publishTrack(webinarVideoTrack.value);
    
    isStreamingWebinarVideo.value = true;
    
    console.log('✅ Webinar Video wird direkt gestreamt');
    console.log('🎬 Webinar Track Name:', webinarVideoTrack.value.name);
    console.log('🎬 Webinar Track SID:', webinarVideoTrack.value.sid);
    console.log('🎬 Room Participant Identity:', room.value.localParticipant.identity);
    
    // DataTrack Nachricht senden
    sendDataMessage({
      type: 'webinarVideoStarted',
      from: 'webinar_' + route.params.teilnahmeid,
      ts: Date.now()
    });

  } catch (error) {
    console.error('❌ Fehler beim Streamen des Webinar Videos:', error);
  }
}

async function stopWebinarVideoStream() {
  try {
    if (webinarVideoTrack.value && room.value) {
      // Video pausieren (aber Track aktiv lassen für Standbild)
      if (webinarVideoEl.value && !webinarVideoEl.value.paused) {
        webinarVideoEl.value.pause();
        console.log('⏸️ Video pausiert - Standbild bleibt aktiv');
      }
      
      isStreamingWebinarVideo.value = false;
      
      console.log('✅ Webinar Video pausiert - Standbild bleibt sichtbar');
      
      // DataTrack Nachricht senden (pausiert, nicht gestoppt)
      sendDataMessage({
        type: 'webinarVideoPaused',
        from: 'admin_' + route.params.terminid,
        ts: Date.now()
      });
    }
  } catch (error) {
    console.error('❌ Fehler beim Pausieren des Webinar Video Streams:', error);
  }
}

// Neue Funktion: Webinar Video komplett stoppen (falls gewünscht)
async function stopWebinarVideoCompletely() {
  try {
    if (webinarVideoTrack.value && room.value) {
      // Track unpublishen
      room.value.localParticipant.unpublishTrack(webinarVideoTrack.value);
      
      // Track stoppen
      webinarVideoTrack.value.stop();
      webinarVideoTrack.value = null;
      
      isStreamingWebinarVideo.value = false;
      
      // Video pausieren
      if (webinarVideoEl.value && !webinarVideoEl.value.paused) {
        webinarVideoEl.value.pause();
      }
      
      console.log('✅ Webinar Video komplett gestoppt');
      
      // DataTrack Nachricht senden
      sendDataMessage({
        type: 'webinarVideoStopped',
        from: 'admin_' + route.params.terminid,
        ts: Date.now()
      });
    }
  } catch (error) {
    console.error('❌ Fehler beim kompletten Stoppen des Webinar Video Streams:', error);
  }
  }

// Lokales Mikrofon hart an/aus (unpublish/publish)
async function toggleLocalAudio() {
  try {
    if (!room.value) return;

    // FALL 1: Audio ist aktiv → komplett ausschalten (unpublish + stop)
    if (isAudioPublished.value && localAudioTrack.value) {
      console.log('🔇 toggleLocalAudio -> Audio AUS');
      try {
        await room.value.localParticipant.unpublishTrack(localAudioTrack.value);
      } catch (e) {
        console.warn('⚠️ unpublishTrack (Audio) fehlgeschlagen:', e);
      }
      try {
        localAudioTrack.value.stop();
      } catch (e) {
        console.warn('⚠️ stop() (Audio) fehlgeschlagen:', e);
      }
      localAudioTrack.value = null;
      isAudioPublished.value = false;
      updatePublishFlags();
      updateAllTeilnehmerInRoom();
      return;
    }

    // FALL 2: Audio ist aus → neues Audio-Track erstellen und publizieren
    console.log('🔊 toggleLocalAudio -> Audio AN (starte neues Audio)');
    await startLocalAudio(); // erstellt + published neuen Audio-Track
    isAudioPublished.value = true;
    updatePublishFlags();
    updateAllTeilnehmerInRoom();
  } catch (e) {
    console.error('❌ toggleLocalAudio Fehler:', e);
  }
}

async function getAdminSession() {
    await getToken();
   
}



async function checkIfTokenIsSet() {
  console.log('checkIfTokenIsSet');
  let data = {
    action: 'checkIfTokenIsSet',
    id: route.params.teilnahmeid,
    hash: route.params.hash,
    admin: 1,
  }
  const response = await baseCalls.webinarPost(data);
  if (response.data.success == true) {
    console.log('checkIfTokenIsSet token is set');
    token.value = response.data.token;
    tokenBis.value = response.data.bisDate;
    console.log(response.data.token);
    userStore.setToken(response.data.token);
    userStore.setWebinarTerminId(response.data.terminId);
    webinarStarted.value = true;
    webinarTerminId.value = response.data.terminId;
    wteiId.value = response.data.wteiId;
    console.log(userStore.userWebinarTerminId);
    joinRoom();
  }
  else {
    console.log('checkIfTokenIsSet token is not set');
  }
}

async function getTokenDirect() {
  let data = {
    action: 'getWebinarAudienceUserTokenDirect',
    id: route.params.teilnahmeid,
    hash: route.params.hash,
    admin: 1,
  }
  loaderStore.setLoader(true, "Das Webinar wird gestartet...");
  const response = await baseCalls.webinarPost(data);
  if (response.data.success == true) {
    loaderStore.setLoader(false);
    token.value = response.data.token;
    console.log(response.data.token);
    userStore.setToken(response.data.token);
    userStore.setWebinarTerminId(response.data.terminId);
    webinarStarted.value = true;
    webinarTerminId.value = response.data.terminId;
    wteiId.value = response.data.wteiId;
    console.log(userStore.userWebinarTerminId);
    // if (wteiId.value == 181) {
      
    // }
      joinRoom();
  } else {
    token.value = response.data.token;
    console.log(response.data.message);
  }
}

async function getToken() {
  console.log('getToken');
 if (!isOpen.value) {
  console.log('Webinar ist nicht offen');
  return;
 }
  let data = {
    action: 'getWebinarAudienceUserToken',
    id: route.params.teilnahmeid,
    hash: route.params.hash,
    admin: 1,
  }
  loaderStore.setLoader(true, "Das Webinar wird gestartet...");
  const response = await baseCalls.webinarPost(data);
  if (response.data.success == true) {
    token.value = response.data.token;
    console.log(response.data.token);
    userStore.setToken(response.data.token);
    userStore.setWebinarTerminId(response.data.terminId);
    webinarStarted.value = true;
    tokenBis.value = response.data.bisDate;
    webinarTerminId.value = response.data.terminId;
    wteiId.value = response.data.wteiId;
    console.log(userStore.userWebinarTerminId);
    // if (wteiId.value == 181) {
      
    // }
    loaderStore.setLoader(false);
      joinRoom();
  } 
}

// Watcher für videoIsRunning - führt getFragen alle 10 Sekunden aus

// Watcher für Chat-Nachrichten: automatisch nach unten scrollen
watch(chatMessages, () => {
  scrollChatToBottom();
}, { deep: true });

watch(room, (newRoom) => {
  if (newRoom) {
    logAllParticipants();
    
    // Wenn verbunden UND Chat bereits geladen ist, zum neuesten Chat scrollen
    if (chatMessages.value.length > 0) {
      scrollChatToBottomForced();
    }
  }
});

// Watch für numberPictureBroadCast - preload upcoming slides
watch(numberPictureBroadCast, (newNumber, oldNumber) => {
  console.log('📊 Slide changed from', oldNumber, 'to', newNumber);
  preloadUpcomingSlides();
});

// Watch für activePictureBroadCast - preload current slide
watch(activePictureBroadCast, (newBroadcast) => {
  if (newBroadcast && newBroadcast.url) {
    if (newBroadcast.type === 'video' && !preloadedVideos.value.has(newBroadcast.url)) {
      console.log('🎬 Preloading current video:', newBroadcast.url);
      preloadedVideos.value.add(newBroadcast.url);
    } else if (newBroadcast.type === 'picture' && !preloadedImages.value.has(newBroadcast.url)) {
      console.log('🖼️ Preloading current image:', newBroadcast.url);
      preloadedImages.value.add(newBroadcast.url);
    }
  }
}, { deep: true });

// Watcher für activeFrage - aktualisiert Video-Display
watch(activeFrage, (newActiveFrage, oldActiveFrage) => {
  console.log('🔄 ActiveFrage geändert:', oldActiveFrage?.teilnehmerid, '→', newActiveFrage?.teilnehmerid);
  
  // Alle aktuellen Videos entfernen
  const audienceContainer = document.getElementById('audience-videos');
  if (audienceContainer) {
    audienceContainer.innerHTML = '';
    console.log('🧹 Audience-Videos Container geleert');
  }
  
  // AudienceVideoIsRunning zurücksetzen
  AudienceVideoIsRunning.value = false;
  
  // Wenn neue activeFrage vorhanden ist, Videos neu laden
  if (newActiveFrage && room.value) {
    console.log('🔄 Lade Videos für neue activeFrage:', newActiveFrage.teilnehmerid);
    
    // Alle Teilnehmer durchgehen und Videos für activeFrage anzeigen
    const participants = Array.from(room.value.participants.values());
    participants.forEach(participant => {
      const participantId = participant.identity.replace('audience_', '');
      
      if (participantId == newActiveFrage.teilnehmerid) {
        console.log('🎥 Gefunden: Teilnehmer für activeFrage:', participant.identity);
        
        // Video-Tracks dieses Teilnehmers anzeigen
        participant.videoTracks.forEach(publication => {
          if (publication.isSubscribed && publication.track) {
            console.log('🎥 Zeige Video für activeFrage:', participant.identity);
            displayRemoteTrack(publication.track, participant);
          }
        });
      }
    });
  }
});
watch(dataTrackMessages, (newMessages) => {
 
  if (newMessages.length > 0) {
    
    const latestMessage = newMessages[newMessages.length - 1];
    console.log('🔍 DataTrack Message Type:', latestMessage.type);
    console.log('🔍 DataTrack Message From:', latestMessage.from);
    console.log('🔍 DataTrack Message Content:', latestMessage.content);
    
    // Nur empfangene Nachrichten verarbeiten (von anderen Teilnehmern)
    if (latestMessage.type === 'received' || latestMessage.type === 'sent') {
      try {
        const messageData = JSON.parse(latestMessage.content);
        console.log('📨 Parsed messageData:', messageData);
        
        // Broadcast-Nachrichten (ohne 'to'-Parameter) verarbeiten
        if (messageData.type === 'neuerUser') {
            console.log('👤 Neuer User empfangen:', messageData.from || messageData.identity);
            getAudience();
          }
          if (messageData.type === 'neueFragen') {
            console.log('👤 Neue Fragen empfangen:', messageData.from || messageData.identity);
            getFragen();
            getWebinarStats();
          }
          if (messageData.type === 'neuesDanke') {
            console.log('👤 Neue neuesDanke empfangen:', messageData.from || messageData.identity);
            getAudience();
          }
          // Reaktionen von Audience-Teilnehmern
          if (messageData.type === 'userDanke') {
            console.log('❤️ Danke-Reaktion empfangen von:', messageData.from);
            showReactionAnimation('userDanke');
            getWebinarStats();
          }
          if (messageData.type === 'userInteressant') {
            console.log('🔥 Interessant-Reaktion empfangen von:', messageData.from);
            showReactionAnimation('userInteressant');
            getWebinarStats();
          }
          if (messageData.type === 'userHallo') {
            console.log('👋 Hallo-Reaktion empfangen von:', messageData.from);
            showReactionAnimation('userHallo');
          }
          if (messageData.type === 'neueUserFragen') {
            console.log('❓ Neue Frage empfangen von:', messageData.from);
            showReactionAnimation('neueUserFragen');
            getFragen();
            getWebinarStats();
          }
          if (messageData.type === 'chatMessage') {
            console.log('💬 Chat-Nachricht empfangen:', messageData);
            // Eigene Nachrichten nicht doppelt hinzufügen (wurden bereits in sendChatMessage hinzugefügt)
            if (messageData.from === 'admin_' + wteiId.value) {
              return;
            }
            if (messageData.text) {
              // Neueste Nachricht unten anzeigen
              chatMessages.value.push({
                from: messageData.from,
                displayName: getNameFromTeilnehmer(messageData.from, 'name'),
                text: messageData.text,
                ts: messageData.timestamp || Date.now()
              });
              // Zum neuesten Chat scrollen
              scrollChatToBottom();
            }
          }
          if (messageData.type === 'videoOn') {
            console.log('👤 MX77 Video von anderen User (nicht admin)  empfangen:', messageData.from || messageData.identity);
           
          }

          if (messageData.type === 'userVideoOff') {
            console.log('👤 User Video Off empfangen:', messageData.from || messageData.identity);
            
            // Video aus Multi-Video-System entfernen
            const identity = messageData.from || messageData.identity;
            removeActiveVideo(identity);
            
            // Altes System (Fallback)
            if (activeVideos.value.length === 0) {
            videoContainerClassAudience.value = 'hidden-video-container';
            AudienceVideoIsRunning.value = false;
            speakerName.value = '';
            activeFrage.value = false;
            }
            setTimeout(() => {
              getFragen();
            }, 2000);
          
          }
        
        
      } catch (e) {
        // Nachricht ist kein JSON - ignorieren
        console.log('📝 Nicht-JSON Nachricht ignoriert:', latestMessage.content, e);
      }
    } else {
      console.log('⏭️ Eigene Nachricht ignoriert (sent)');
    }
  }
}, { deep: true });

// Bestehende wtb_webinar_fragen beim Start einmalig in den Chat übernehmen
watch(fragen, (newFragen) => {
  if (
    initialChatLoaded.value ||
    !Array.isArray(newFragen) ||
    newFragen.length === 0
  ) {
    return;
  }

  try {
    // Fragen übernehmen (kommen bereits chronologisch sortiert aus DB - älteste zuerst)
    const mapped = newFragen.map((item) => ({
      from: 'audience_' + item.teilnehmerid,
      displayName: item.name,
      text: item.frage,
      // Grobe Zeitrekonstruktion aus "vor X Minuten"
      ts: Date.now() - (item.vor || 0) * 60 * 1000,
    }));

    chatMessages.value = mapped;
    initialChatLoaded.value = true;
    console.log('✅ Initiale Chat-History aus wtb_webinar_fragen geladen:', mapped.length);
    
    // Nach initialem Laden zum neuesten Chat scrollen (mit mehreren Versuchen)
    scrollChatToBottomForced();
  } catch (e) {
    console.warn('Fehler beim Initial-Mappen der Fragen in den Chat:', e);
  }
}, { deep: true });



// DataTrack Hilfsfunktionen
function getMyDataTrack() {
	if (localDataTrack.value) return localDataTrack.value;
	if (!room.value) return null;
	for (const publication of room.value.localParticipant.tracks.values()) {
		if (publication.track && publication.track.kind === 'data') {
			return publication.track;
		}
	}
	return null;
}

// function getParticipantDataTracks(participant) {
// 	const dataTracks = [];
// 	participant.tracks.forEach(publication => {
// 		if (publication.track && publication.track.kind === 'data') {
// 			dataTracks.push(publication.track);
// 		}
// 	});
// 	return dataTracks;
// }

// function setupDataTrackForParticipant(participant) {
// 	// Bereits vorhandene DataTracks
// 	participant.tracks.forEach(publication => {
// 		if (publication.isSubscribed && publication.track && publication.track.kind === 'data') {
// 			bindDataTrackEvents(publication.track, participant.identity);
// 		}
// 		publication.on('subscribed', track => {
// 			if (track.kind === 'data') bindDataTrackEvents(track, participant.identity);
// 		});
// 	});

// 	// Zukünftige DataTracks
// 	participant.on('trackSubscribed', track => {
// 		if (track.kind === 'data') bindDataTrackEvents(track, participant.identity);
// 	});
// }

function bindDataTrackEvents(dataTrack, identity) {
	// Überprüfen, ob bereits Event-Listener für diesen DataTrack registriert sind
	if (dataTrack._eventListenersBound) {
		console.log(`⚠️ Event-Listener für DataTrack von ${identity} bereits registriert - überspringe`);
		return;
	}
	
	console.log(`🔗 Registriere Event-Listener für DataTrack von ${identity}`);
	
	dataTrack.on('message', msg => {
		try {
			const text = typeof msg === 'string' ? msg : new TextDecoder().decode(msg);
			console.log(`📩 DataTrack von ${identity}:`, text);
			
			// Nachricht zur Anzeige hinzufügen
			addDataTrackMessage({
				type: 'received',
				from: identity,
				content: text,
				timestamp: new Date().toLocaleTimeString()
			});
		} catch (e) {
			console.log(`📩 DataTrack (binär) von ${identity}:`, msg);
			addDataTrackMessage({
				type: 'received',
				from: identity,
				content: '[Binäre Nachricht]',
				timestamp: new Date().toLocaleTimeString()
			});
		}
	});
	
	// Markieren, dass Event-Listener registriert sind
	dataTrack._eventListenersBound = true;
}

function sendDataMessage(message) {
	const track = getMyDataTrack();
	if (!track) {
		console.warn('Kein lokaler DataTrack gefunden');
		return false;
	}
	try {
		const messageText = typeof message === 'string' ? message : JSON.stringify(message);
		track.send(messageText);
		console.log('📤 Gesendet:', message);
		
		// Gesendete Nachricht zur Anzeige hinzufügen
		addDataTrackMessage({
			type: 'sent',
			from: 'Sie',
			content: messageText,
			timestamp: new Date().toLocaleTimeString()
		});
		
		return true;
	} catch (e) {
		console.error('Senden fehlgeschlagen:', e);
		return false;
	}
}

// Hilfsfunktionen für DataTrack-Anzeige
function addDataTrackMessage(message) {
	dataTrackMessages.value.push(message);
	// Maximal 50 Nachrichten behalten
	if (dataTrackMessages.value.length > 50) {
		dataTrackMessages.value.shift();
	}
}

function sendTestMessage() {
	if (testMessage.value.trim()) {
		sendDataMessage(testMessage.value.trim());
		testMessage.value = '';
	}
}

// Chat nach unten scrollen
function scrollChatToBottom() {
  nextTick(() => {
    if (chatMessagesContainer.value) {
      chatMessagesContainer.value.scrollTop = chatMessagesContainer.value.scrollHeight;
      console.log('📜 Chat gescrollt:', chatMessagesContainer.value.scrollTop, '/', chatMessagesContainer.value.scrollHeight);
    } else {
      console.warn('⚠️ chatMessagesContainer nicht verfügbar für Scroll');
    }
  });
}

// Chat nach unten scrollen mit mehreren Versuchen (für initiales Laden)
function scrollChatToBottomForced() {
  const tryScroll = (attempt = 1) => {
    nextTick(() => {
      if (chatMessagesContainer.value) {
        chatMessagesContainer.value.scrollTop = chatMessagesContainer.value.scrollHeight;
        console.log(`📜 Chat gescrollt (Versuch ${attempt}):`, chatMessagesContainer.value.scrollTop, '/', chatMessagesContainer.value.scrollHeight);
      } else if (attempt < 5) {
        console.log(`⏳ Container noch nicht bereit, Versuch ${attempt}/5...`);
        setTimeout(() => tryScroll(attempt + 1), 200);
      }
    });
  };
  tryScroll();
}

// Chat-Nachricht auch in wtb_webinar_fragen speichern
async function saveChatMessageToDb(text) {
  try {
    const data = {
      action: 'saveFrage',
      frage: text,
      terminid: terminData.value.wter_id,
      teilnehmerid: wteiId.value,
    };
    await baseCalls.webinarPost(data);
  } catch (error) {
    console.error('Fehler beim Speichern der Chat-Nachricht:', error);
  }
}

function sendChatMessage() {
  const text = chatInput.value.trim()
  if (!text) return

  const payload = {
    type: 'chatMessage',
    from: 'admin_' + wteiId.value,
    text,
    timestamp: Date.now()
  }

  // nur über DataTrack versenden
  sendDataMessage(payload)
  saveChatMessageToDb(text)
  
  // Eigene Nachricht direkt zum Chat hinzufügen
  chatMessages.value.push({
    from: 'admin_' + wteiId.value,
    displayName: 'Ich',
    text: text,
    ts: Date.now()
  });
  
  chatInput.value = ''
  
  // Zum neuesten Chat scrollen
  scrollChatToBottom();
}

async function startSession() {
  if (userToken.value != null) {
    console.log('startSession Token');
    webinarStarted.value = true;
    token.value = userToken.value;
    webinarTerminId.value = userWebinarTerminId.value;
    if (!videoIsRunning.value && isConnected.value){
      joinRoom();
    }
  }
  else {
    checkIfTokenIsSet();
  }
}

// User Interaction Functions
function addToLog(type, details, color = '#333') {
  const now = new Date().toLocaleTimeString();
  interactionLog.value.unshift({
    time: now,
    type: type,
    details: details,
    color: color
  });
  
  // Nur die letzten 10 Einträge behalten
  if (interactionLog.value.length > 10) {
    interactionLog.value.pop();
  }
}

function setupInteractionMonitoring() {
  // Mouse Move Tracking
  const handleMouseMove = (event) => {
    mousePosition.value = { x: event.clientX, y: event.clientY };
  };
  
  // Mouse Click Tracking
  const handleMouseClick = (event) => {
    const buttonNames = ['Links', 'Mitte', 'Rechts'];
    const buttonName = buttonNames[event.button] || `Button ${event.button}`;
    
    lastMouseClick.value = {
      button: buttonName,
      x: event.clientX,
      y: event.clientY,
      time: new Date().toLocaleTimeString()
    };
    
    addToLog('🖱️ Mausklick', `${buttonName} bei (${event.clientX}, ${event.clientY})`, '#2196F3');
  };
  
  // Keyboard Tracking
  const handleKeyDown = (event) => {
    if (!activeKeys.value.includes(event.key)) {
      activeKeys.value.push(event.key);
    }
    
    lastKeyPress.value = {
      key: event.key,
      code: event.code,
      time: new Date().toLocaleTimeString()
    };
    
    addToLog('⌨️ Taste gedrückt', `"${event.key}" (${event.code})`, '#4CAF50');
  };
  
  const handleKeyUp = (event) => {
    const index = activeKeys.value.indexOf(event.key);
    if (index > -1) {
      activeKeys.value.splice(index, 1);
    }
    
    addToLog('⌨️ Taste losgelassen', `"${event.key}"`, '#FF9800');
  };
  
  // Scroll Tracking
  const handleScroll = (event) => {
    const direction = event.deltaY > 0 ? 'Runter' : 'Hoch';
    
    lastScroll.value = {
      direction: direction,
      deltaY: event.deltaY,
      time: new Date().toLocaleTimeString()
    };
    
    scrollPosition.value = {
      x: window.scrollX,
      y: window.scrollY
    };
    
    addToLog('📜 Scrollen', `${direction} (${event.deltaY})`, '#9C27B0');
  };
  
  // Event Listeners registrieren
  document.addEventListener('mousemove', handleMouseMove);
  document.addEventListener('mousedown', handleMouseClick);
  document.addEventListener('keydown', handleKeyDown);
  document.addEventListener('keyup', handleKeyUp);
  document.addEventListener('wheel', handleScroll);
  
  // Cleanup beim Unmount
  onUnmounted(() => {
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mousedown', handleMouseClick);
    document.removeEventListener('keydown', handleKeyDown);
    document.removeEventListener('keyup', handleKeyUp);
    document.removeEventListener('wheel', handleScroll);
  });
}

async function recoverVideoAfterPermissionRestore() {
  console.log('🔄 Video-Wiederherstellung nach Berechtigung...');
  
  if (!selectedCameraId.value) {
    console.warn('⚠️ Keine Kamera ausgewählt für Recovery');
    return;
  }
  
  try {
    // Neuen Video-Track erstellen
    const newVideoTrack = await createVideoTrackForCamera(selectedCameraId.value);
    if (!newVideoTrack) {
      console.error('❌ Video-Track konnte nicht erstellt werden');
      return;
    }
    
    // Alten Track entfernen falls vorhanden
    if (localVideoTrack.value && room.value) {
      try {
        await room.value.localParticipant.unpublishTrack(localVideoTrack.value);
        localVideoTrack.value.stop();
      } catch (e) {
        console.warn('⚠️ Alten Track unpublish fehlgeschlagen:', e);
      }
    }
    
    localVideoTrack.value = markRaw(newVideoTrack);
    
    // Track publishen
    if (room.value) {
      await room.value.localParticipant.publishTrack(newVideoTrack);
      isVideoPublished.value = true;
      updatePublishFlags();
    }
    
    // Video in BEIDEN View-Modi anzeigen
    await nextTick();
    
    // 1. Haupt-Video-Element (normal view)
    if (localVideoEl.value && !presentationViewStarted.value) {
      try {
        newVideoTrack.attach(localVideoEl.value);
        videoIsRunning.value = true;
        console.log('✅ Video im Haupt-Element wiederhergestellt');
      } catch (e) {
        console.warn('⚠️ Attach am localVideoEl fehlgeschlagen:', e);
      }
    }
    
    // 2. Inline-Preview-Element (presentation view)
    if (presentationViewStarted.value && localInlineVideoEl.value) {
      try {
        newVideoTrack.attach(localInlineVideoEl.value);
        console.log('✅ Video im Inline-Element wiederhergestellt');
      } catch (e) {
        console.warn('⚠️ Attach am localInlineVideoEl fehlgeschlagen:', e);
      }
    }
    
    console.log('✅ Video-Wiederherstellung abgeschlossen');
  } catch (error) {
    console.error('❌ Video-Wiederherstellung fehlgeschlagen:', error);
  }
}

function setupMediaDeviceRecovery() {
  // Listener für Geräteänderungen (Berechtigungen, USB-Geräte, etc.)
  const handleDeviceChange = async () => {
    console.log('📱 Device change detected');
    
    // Nur reagieren wenn wir verbunden sind
    if (!isConnected.value || !room.value) return;
    
    // Prüfen ob aktuelle Tracks noch live sind
    const videoTrackLive = localVideoTrack.value?.mediaStreamTrack?.readyState === 'live';
    const audioTrackLive = localAudioTrack.value?.mediaStreamTrack?.readyState === 'live';
    
    console.log('🔍 Track Status nach Device Change:', {
      videoTrackLive,
      audioTrackLive,
      isVideoPublished: isVideoPublished.value,
      isAudioPublished: isAudioPublished.value,
      videoIsRunning: videoIsRunning.value
    });
    
    // Video wiederherstellen wenn Track ended ist aber wir publishen wollen
    if (!videoTrackLive && videoIsRunning.value && isVideoPublished.value) {
      console.log('🔄 Video-Track ended, starte Wiederherstellung...');
      await recoverVideoAfterPermissionRestore();
    }
    
    // Audio wiederherstellen wenn Track ended ist aber wir publishen wollen
    if (!audioTrackLive && isAudioPublished.value) {
      console.log('🔄 Audio-Track ended, versuche Wiederherstellung...');
      try {
        await startLocalAudio();
        console.log('✅ Audio-Track wiederhergestellt');
      } catch (error) {
        console.warn('⚠️ Audio-Wiederherstellung fehlgeschlagen:', error);
      }
    }
  };
  
  navigator.mediaDevices.addEventListener('devicechange', handleDeviceChange);
  
  // Cleanup
  onUnmounted(() => {
    navigator.mediaDevices.removeEventListener('devicechange', handleDeviceChange);
  });
}

// Track-ended Events überwachen
function setupTrackEndedHandlers() {
  watch(localVideoTrack, (track) => {
    if (track?.mediaStreamTrack) {
      track.mediaStreamTrack.addEventListener('ended', async () => {
        console.warn('⚠️ Video-Track ended (Berechtigung widerrufen?)');
        isVideoPublished.value = false;
        videoIsRunning.value = false;
        
        // Versuche automatisch wiederherzustellen nach kurzer Verzögerung
        setTimeout(async () => {
          console.log('🔄 Versuche automatische Video-Wiederherstellung...');
          await recoverVideoAfterPermissionRestore();
        }, 2000);
      });
    }
  });
  
  watch(localAudioTrack, (track) => {
    if (track?.mediaStreamTrack) {
      track.mediaStreamTrack.addEventListener('ended', async () => {
        console.warn('⚠️ Audio-Track ended (Berechtigung widerrufen?)');
        isAudioPublished.value = false;
        
        // Versuche automatisch wiederherzustellen nach kurzer Verzögerung
        setTimeout(async () => {
          console.log('🔄 Versuche automatische Audio-Wiederherstellung...');
          try {
            await startLocalAudio();
            console.log('✅ Audio-Track wiederhergestellt');
          } catch (error) {
            console.warn('⚠️ Audio-Wiederherstellung fehlgeschlagen:', error);
          }
        }, 2000);
      });
    }
  });
}

onMounted(async () => {
  if (route.params.debug == 1) {
    showDebug.value = true;
    setupInteractionMonitoring(); // Nur im Debug-Modus aktivieren
  }
  
  // Media Device Recovery Setup
  setupMediaDeviceRecovery();
  setupTrackEndedHandlers();
  
  // Keyboard shortcuts für Overlays
  const handleOverlayKeyboard = (event) => {
    // F1 = Teilnehmer Overlay toggle
    if (event.key === 'F1') {
      event.preventDefault();
      if (audience.value && audience.value.length > 0) {
        toggleFragenOverlayVisibility();
      }
    }
    // F2 = Fragen Overlay toggle
    if (event.key === 'F2') {
      event.preventDefault();
      if (fragen.value && fragen.value.length > 0) {
        toggleActiveFragenOverlay();
      }
    }
  };
  
  document.addEventListener('keydown', handleOverlayKeyboard);
  
  // Cleanup function für Overlay Keyboard Events
  onUnmounted(() => {
    document.removeEventListener('keydown', handleOverlayKeyboard);
  });
  
  getTerminData();
  updateDocumentHead(
    "Webinar - Webinare für Zahnärzte & ZFA",
    "Webinare für Zahnärzte & ZFA"
  );
  
  // Kameras laden
  await getVideoDevices();
  await refreshMediaPermissions();
  permissionOrigin.value = window.location.origin || '';
  permissionHost.value = window.location.hostname || '';
  
  // Keyboard Event Listener für Pfeiltasten
  const handleKeydown = (event) => {
    if (switchPresentationButton.value) {
      return;
    }
    if (event.key === ' ') {
      event.preventDefault();
      if (numberPictureBroadCast.value < countSlides.value) {
        setPictureBroadCast(1, 'plus');
      }
    } else if (event.key === 'Tab' || event.key === 'CapsLock' || event.key === 'Shift') {
      event.preventDefault();
      if (numberPictureBroadCast.value > 1) {
        setPictureBroadCast(1, 'minus');
      }
    }
  };
  
  
  // Event Listener nur auf sliderDiv anwenden
  document.addEventListener('keydown', handleKeydown);
  
  // Cleanup beim Unmount
  onUnmounted(() => {
    document.removeEventListener('keydown', handleKeydown);
 
  });
});

</script>

<style scoped>
/* Alle Rundungen entfernen */
.v-card,
.v-btn,
.v-chip,
.v-avatar {
  border-radius: 0 !important;
}

.self-preview video {
  transform: scaleX(-1);
}

.teacher-presentation-inline-wrapper {
  width: 100%;
  margin-bottom: 16px;
}

.teacher-presentation-stage {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #000;
  overflow: hidden;
  border: 2px solid #1c1c1c;
}

.teacher-presentation-media {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}

.teacher-inline-preview {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 220px;
  height: 150px;
  border: 2px solid #ffffff;
  box-shadow: 0 4px 12px rgba(0,0,0,0.4);
  background: #000;
  z-index: 8;
}

.teacher-inline-preview-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.teacher-main-video-container {
  position: relative;
  width: 100%;
  max-width: 100%;
  aspect-ratio: 16 / 9;
  background: #000;
  overflow: hidden;
}

.teacher-main-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border: 4px solid #39ba12;
  background: #000;
}

.teacher-main-video-status {
  position: absolute;
  bottom: 10px;
  right: 10px;
  display: flex;
  gap: 8px;
  z-index: 10;
}

.teacher-status-chip {
  background: rgba(0, 0, 0, 0.8);
  border-radius: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.teacher-main-video-controls {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  gap: 8px;
  z-index: 10;
}

.teacher-main-video-controls-bar {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-bottom: 8px;
  position: sticky;
  top: 10px;
  z-index: 20;
  background: rgba(255, 255, 255, 0.85);
  padding: 6px 8px;
}

.teacher-video-placeholder {
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #000;
  position: relative;
  overflow: hidden;
}

.teacher-video-placeholder-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.9;
}

.teacher-video-placeholder-text {
  position: relative;
  z-index: 2;
  color: white;
  padding: 16px;
  text-align: center;
}

/* Draggable Fragen Overlay Styles */
.draggable-fragen-overlay {
  background: white;
  border: 2px solid #3166a5;
  border-radius: 0;
  box-shadow: 0 4px 20px rgba(0,0,0,0.3);
  overflow: hidden;
  user-select: none;
}

.fragen-overlay-header {
  background: #3166a5;
  color: white;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  cursor: move;
  font-weight: bold;
  font-size: 16px;
}

.fragen-overlay-minimize {
  background: none !important;
  box-shadow: none !important;
}

.fragen-overlay-minimize:hover {
  background: rgba(255,255,255,0.2) !important;
}

.fragen-overlay-content {
  max-height: calc(90vh - 35px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 15px;
  height: auto;
  min-height: fit-content;
  scrollbar-width: thin;
  scrollbar-color: #2196F3 #f1f1f1;
}

.fragen-overlay-content::-webkit-scrollbar {
  width: 8px;
}

.fragen-overlay-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 0;
}

.fragen-overlay-content::-webkit-scrollbar-thumb {
  background: #2196F3;
  border-radius: 0;
}

.fragen-overlay-content::-webkit-scrollbar-thumb:hover {
  background: #1976D2;
}

/* Draggable Active Fragen Overlay Styles */
.draggable-active-fragen-overlay {
  background: white;
  border: 2px solid #FF9800;
  border-radius: 0;
  box-shadow: 0 4px 20px rgba(0,0,0,0.3);
  overflow: hidden;
  user-select: none;
}

.active-fragen-overlay-header {
  background: #FF9800;
  color: white;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  cursor: move;
  font-weight: bold;
  font-size: 16px;
}

.active-fragen-overlay-minimize {
  background: none !important;
  box-shadow: none !important;
}

.active-fragen-overlay-minimize:hover {
  background: rgba(255,255,255,0.2) !important;
}

.active-fragen-overlay-content {
  max-height: calc(90vh - 35px);
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 15px;
  height: auto;
  min-height: 200px;
  scrollbar-width: thin;
  scrollbar-color: #FF9800 #f1f1f1;
}

.active-fragen-overlay-content::-webkit-scrollbar {
  width: 8px;
}

.active-fragen-overlay-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 0;
}

.active-fragen-overlay-content::-webkit-scrollbar-thumb {
  background: #FF9800;
  border-radius: 0;
}

.active-fragen-overlay-content::-webkit-scrollbar-thumb:hover {
  background: #F57C00;
}

/* Floating Action Buttons für Overlay Reopening */
.floating-reopen-btn {
  box-shadow: 0 4px 12px rgba(0,0,0,0.3) !important;
  transition: all 0.3s ease !important;
  position: fixed !important;
  z-index: 1001 !important;
}

.floating-reopen-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 16px rgba(0,0,0,0.4) !important;
}

.overlay-controls {
  position: relative;
  z-index: 1001;
}

.overlay-controls .v-btn {
  pointer-events: all !important;
  display: block !important;
  visibility: visible !important;
}

.video-container {
  width: 100%;
  height: 300px;
  background: #f0f0f0;
  border: 2px solid #39ba12;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.video-container video {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;



}

.co-admin-badge {
  position: absolute;
  top: 0;
  left: 0;
  background-color: orange;
  color: white;
  padding: 5px 10px;
  border-radius: 0;
  font-weight: bold;
  z-index: 10;
}

/* Reaktions-Animation */
.reaction-fade-enter-active, .reaction-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.reaction-fade-enter-from {
  opacity: 0;
  transform: scale(0.5);
}

.reaction-fade-leave-to {
  opacity: 0;
  transform: scale(1.5);
}

.reaction-pulse {
  animation: reaction-pulse 1s ease-in-out;
}

@keyframes reaction-pulse {
  0% { 
    transform: scale(0.5); 
    opacity: 0; 
  }
  50% { 
    transform: scale(1.1); 
    opacity: 1; 
  }
  100% { 
    transform: scale(1); 
    opacity: 1; 
  }
}

/* Chat Styles */
.chat-message {
  border-bottom: 1px solid #eee;
  padding: 6px;
}

.chat-message--me {
  background-color: #e8f5e9; /* helles Grün */
}

.end-webinar-confirm {
  border: 2px solid #f44336;
  background: rgba(244, 67, 54, 0.05);
  padding: 12px;
  border-radius: 0;
}

.confirm-title {
  font-weight: 600;
  color: #b71c1c;
  margin-bottom: 4px;
  text-transform: uppercase;
  font-size: 0.85rem;
}
</style>
